// import React, { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import {
//   Container,
//   Card,
//   Row,
//   Col,
//   Form,
//   Button,
//   Table,
//   Badge,
//   Spinner,
// } from "react-bootstrap";
// import {
//   FaBolt,
//   FaBroom,
//   FaCogs,
//   FaFire,
//   FaSnowflake,
//   FaFilter as FaFilterIcon,
//   FaUser,
//   FaPhone,
//   FaMapMarkerAlt,
//   FaCalendar,
//   FaPlus,
//   FaMinus,
//   FaClipboardCheck,
// } from "react-icons/fa";
// import { URL } from "../../../config";

// // bring your shared maps
// import { serviceFields } from "../../Services/serviceFields";
// import SERVICE_PRICING, {
//   SERVICE_PRICING as ALL_PRICING,
//   AC_PRICING,
// } from "../../Services/servicePricing";
// import "./AdminPlaceOrder.css";

// /* ---------- small helpers ---------- */
// const pad2 = (n) => String(n).padStart(2, "0");
// const todayISO = () => {
//   const d = new Date();
//   return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
// };
// const generateSlots = () => {
//   const out = [];
//   for (let h = 7; h <= 21; h++) {
//     for (let m = 0; m < 60; m += 30) {
//       let dh = h % 12;
//       if (dh === 0) dh = 12;
//       out.push(`${dh}:${pad2(m)} ${h < 12 ? "AM" : "PM"}`);
//     }
//   }
//   return out;
// };

// /* ---------- pricing helpers (same as backend) ---------- */
// const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };
// const MAP_PLUMBER = {
//   angle_valve_setup: "angleValveSetup",
//   basin_tap_setup: "basinTapSetup",
//   magic_pipe_setup: "magicPipeSetup",
//   basin_waste_pop_up_setup: "basinWastePopUpSetup",
//   new_basin_setup_existing_lines: "newBasinSetupExistingLines",
//   bathroom_tap_bib_cock_setup: "bathroomTapBibCockSetup",
//   tissue_holder_setup: "tissueHolderSetup",
//   fill_valve_replacement: "fillValveReplacement",
//   hand_shower_setup: "handShowerSetup",
//   soap_dish_setup: "soapDishSetup",
//   bathroom_shelf_setup: "bathroomShelfSetup",
//   mirror_setup: "mirrorSetup",
//   towel_hanger_setup: "towelHangerSetup",
//   shower_head_setup: "showerHeadSetup",
//   concealed_stopcock_setup: "conceledStopcockSetup",
//   floor_drain_net_setup: "floorDrainNetSetup",
//   toilet_seat_cover_replacement: "toiletSeatCoverReplacement",
//   toilet_seat_complete_installation: "toiletSeatCompleteInstallation",
//   high_commode_installation_existing_lines:
//     "highCommodeInstallationExistingLines",
//   blockage_clearing_high_commode: "blockageClearingHighCommode",
//   blockage_clearing_low_commode: "blockageClearingLowCommode",
//   bathroom_drain_line_cleaning: "bathroomDrainLineCleaning",
//   geyser_installation: "geyserInstallation",
//   kitchen_sink_setup_existing_lines: "kitchenSinkSetupExistingLines",
//   sink_blockage_cleaning: "sinkBlockageCleaning",
//   washing_machine_point_setup: "washingMachinePointSetup",
// };
// const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };
// const MAP_GAS = {
//   NewchulaSetup: "newChulaSetup",
//   chulaSetup: "chulaSetup",
//   burnerSetup: "burnerSetup",
//   burnerCleaning: "burnerCleaning",
//   nozzleReplacement: "nozzleReplacement",
// };
// const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };
// const MAP_FILTER = {
//   new_filter_setup: "newFilterSetup",
//   installation_filter: "installationFilter",
//   uninstallation_filter: "uninstallationFilter",
//   kit_replacement: "kitReplacement",
//   pipe_leak_or_replace: "pipeLeakOrReplace",
//   full_servicing: "fullServicing",
// };
// const FILTER_BOOL_FLAT = { check_up: "checkupFlat" };
// const MAP_HOME_FIRSTFREE = {
//   bed: "bedrooms",
//   kitchen: "kitchens",
//   dra_din: "drawingdinning",
// };
// const MAP_HOME_PERUNIT = {
//   bath: "bathrooms",
//   cloth: "cloths",
//   dish: "dishes",
//   balcony: "balconies",
//   window_grill: "windowGrills",
//   furniture_cleaning: "furniture",
//   stairs_and_railing: "stairsFloors",
//   carpet_cleaning: "carpets",
// };
// const AC_NUMERIC_PROPS = new Set([
//   "installation_outdoor_inside",
//   "installation_outdoor_outside",
//   "uninstallation_outdoor_inside",
//   "uninstallation_outdoor_outside",
//   "cleaning_outdoor_inside",
//   "cleaning_outdoor_outside",
// ]);
// const AC_CHECKUP_KEY = "issue_checkup";
// const acTierTotal = (prop, qty) => {
//   const c = Math.max(0, Number(qty) || 0);
//   if (!c) return 0;
//   const rate = AC_PRICING?.perUnit?.[prop];
//   if (!rate) return 0;
//   return c === 1 ? rate.first : c * rate.additional;
// };
// const acCheckupTotal = (qty) => {
//   const c = Math.max(0, Number(qty) || 0);
//   if (!c) return 0;
//   const {
//     base = 0,
//     includesUnits = 0,
//     extraPerUnit = 0,
//   } = AC_PRICING?.checkup || {};
//   return c <= includesUnits ? base : base + (c - includesUnits) * extraPerUnit;
// };

// /* ---------- per-unit lookup for non-AC/HC ---------- */
// function perUnitRate(service, prop) {
//   const pricing = ALL_PRICING[service];
//   if (!pricing) return 0;
//   if (service === "Electrician") return Number(pricing.perUnit?.[prop] || 0);
//   if (service === "Plumber")
//     return Number(pricing.perUnit?.[MAP_PLUMBER[prop]] || 0);
//   if (service === "Gas Chula")
//     return Number(pricing.perUnit?.[MAP_GAS[prop]] || 0);
//   if (service === "Filter")
//     return Number(pricing.perUnit?.[MAP_FILTER[prop]] || 0);
//   if (service === "Home Cleaning")
//     return Number(pricing.perUnit?.[MAP_HOME_PERUNIT[prop]] || 0);
//   return 0;
// }

// const SERVICE_ICONS = {
//   Electrician: <FaBolt />,
//   "Home Cleaning": <FaBroom />,
//   Plumber: <FaCogs />,
//   "Gas Chula": <FaFire />,
//   "AC Service": <FaSnowflake />,
//   Filter: <FaFilterIcon />,
//   "Tutor Service": <FaUser />,
// };
// const SERVICES = Object.keys(serviceFields);

// /* ---------- Generic field renderer ---------- */
// function NumberStepper({ value = 0, onChange }) {
//   return (
//     <div className="apo-stepper">
//       <Button
//         size="sm"
//         variant="light"
//         onClick={() => onChange(Math.max(0, value - 1))}
//       >
//         <FaMinus />
//       </Button>
//       <div className="apo-stepper-val">{value}</div>
//       <Button size="sm" variant="light" onClick={() => onChange(value + 1)}>
//         <FaPlus />
//       </Button>
//     </div>
//   );
// }

// export default function AdminPlaceOrder() {
//   const [serviceType, setServiceType] = useState("Electrician");
//   const [fields, setFields] = useState({});
//   const [user, setUser] = useState({
//     mobile: "",
//     FirstName: "",
//     LastName: "",
//     city: "",
//     cityCode: "",
//     area: "",
//     Address: "",
//   });
//   const [schedule, setSchedule] = useState({ date: todayISO(), time: "" });
//   const [divisions, setDivisions] = useState([]);
//   const [areas, setAreas] = useState([]);
//   const [placing, setPlacing] = useState(false);

//   const timeSlots = useMemo(() => generateSlots(), []);

//   const [foundUser, setFoundUser] = useState(null); // {Id, FirstName, ...} or null
//   const [lookingUp, setLookingUp] = useState(false);

//   function debounce(fn, delay = 400) {
//     let t;
//     return (...args) => {
//       clearTimeout(t);
//       t = setTimeout(() => fn(...args), delay);
//     };
//   }

//   const doLookup = useMemo(
//     () =>
//       debounce(async (m) => {
//         if (!/^\d{11}$/.test(m)) {
//           setFoundUser(null);
//           return;
//         }
//         try {
//           setLookingUp(true);
//           const { data } = await axios.get(`${URL}/admin/users/lookup`, {
//             params: { mobile: m },
//           });
//           // data is either null or user object
//           setFoundUser(data);
//           if (data) {
//             // auto-fill fields (but let admin edit)
//             setUser((prev) => ({
//               ...prev,
//               mobile: data.mobile || m,
//               FirstName: data.FirstName || "",
//               LastName: data.LastName || "",
//               city: data.city || "",
//               area: data.area || "",
//               Address: data.Address || "",
//               // OPTIONAL: if you stored Id visually
//               userId: data.Id || "",
//             }));
//           } else {
//             // new user path: keep only mobile; blank others for admin to fill
//             setUser((prev) => ({
//               ...prev,
//               mobile: m,
//               FirstName: "",
//               LastName: "",
//               city: "",
//               area: "",
//               Address: "",
//               userId: "",
//             }));
//           }
//         } catch (e) {
//           console.error(e);
//           setFoundUser(null);
//         } finally {
//           setLookingUp(false);
//         }
//       }, 450),
//     [URL]
//   );

//   useEffect(() => {
//     const m = (user.mobile || "").replace(/\s/g, "");
//     if (m.length === 11) {
//       doLookup(m);
//     } else {
//       setFoundUser(null);
//     }
//   }, [user.mobile, doLookup]);

//   // Load cities/divisions
//   useEffect(() => {
//     (async () => {
//       try {
//         const { data } = await axios.get(`${URL}/locations/divisions`);
//         // normalize {name, code}
//         const rows = Array.isArray(data)
//           ? data.map((d) => ({
//               name: d.name || d.division || d.title,
//               code: d.code || d.Code || d.id || d.Id,
//             }))
//           : [];
//         setDivisions(rows);
//       } catch (e) {
//         console.error(e);
//       }
//     })();
//   }, []);

//   // Load areas on city change
//   useEffect(() => {
//     (async () => {
//       if (!user.city && !user.cityCode) {
//         setAreas([]);
//         return;
//       }
//       try {
//         // Backend prefers divisionCode or divisionId. Fall back to division name.
//         const params = user.cityCode
//           ? { divisionCode: user.cityCode } // << change from { code: ... }
//           : { division: user.city }; // this is also accepted by the backend patch
//         const { data } = await axios.get(`${URL}/locations/areas`, { params });
//         const rows = Array.isArray(data)
//           ? data.map((a) => ({ name: a.name || a.area || a.title }))
//           : [];
//         setAreas(rows);
//       } catch (e) {
//         console.error(e);
//         setAreas([]);
//       }
//     })();
//   }, [user.city, user.cityCode]);

//   // live pricing (mirrors backend)
//   const pricing = useMemo(() => {
//     const p = SERVICE_PRICING[serviceType];
//     if (!p) return { subtotal: 0, discount: 0, total: 0 };
//     let sum = p.base ? Number(p.base) : 0;

//     if (serviceType === "AC Service") {
//       Object.keys(fields || {}).forEach((prop) => {
//         if (AC_NUMERIC_PROPS.has(prop)) sum += acTierTotal(prop, fields[prop]);
//       });
//       if (fields[AC_CHECKUP_KEY]) sum += acCheckupTotal(fields[AC_CHECKUP_KEY]);
//       return { subtotal: Math.round(sum), discount: 0, total: Math.round(sum) };
//     }

//     if (serviceType === "Home Cleaning") {
//       Object.entries(MAP_HOME_FIRSTFREE).forEach(([fprop, priceKey]) => {
//         const c = Math.max(0, Number(fields[fprop] || 0));
//         const perAdd = p.firstFree?.[priceKey]?.perAdditional || 0;
//         if (c > 1) sum += (c - 1) * perAdd;
//       });
//       Object.entries(MAP_HOME_PERUNIT).forEach(([fprop, priceKey]) => {
//         const c = Math.max(0, Number(fields[fprop] || 0));
//         const rate = p.perUnit?.[priceKey] || 0;
//         sum += c * rate;
//       });
//       return { subtotal: Math.round(sum), discount: 0, total: Math.round(sum) };
//     }

//     // Generic per-unit + boolean
//     (serviceFields[serviceType] || []).forEach((f) => {
//       if (f.type === "number") {
//         const c = Math.max(0, Number(fields[f.prop] || 0));
//         sum += c * perUnitRate(serviceType, f.prop);
//       } else if (f.type === "boolean") {
//         const yes = !!fields[f.prop];
//         if (serviceType === "Electrician" && f.prop in ELEC_BOOL_FLAT && yes)
//           sum += p[ELEC_BOOL_FLAT[f.prop]] || 0;
//         if (serviceType === "Plumber" && f.prop in PLUMBER_BOOL_FLAT && yes)
//           sum += p[PLUMBER_BOOL_FLAT[f.prop]] || 0;
//         if (serviceType === "Gas Chula" && f.prop in GAS_BOOL_FLAT && yes)
//           sum += p[GAS_BOOL_FLAT[f.prop]] || 0;
//         if (serviceType === "Filter" && f.prop in FILTER_BOOL_FLAT && yes)
//           sum += p[FILTER_BOOL_FLAT[f.prop]] || 0;
//       }
//     });

//     return { subtotal: Math.round(sum), discount: 0, total: Math.round(sum) };
//   }, [serviceType, fields]);

//   const canSubmit =
//     user.mobile &&
//     user.city &&
//     user.area &&
//     user.Address &&
//     schedule.date &&
//     schedule.time;

//   const place = async () => {
//     if (!canSubmit) {
//       alert("Fill all required fields.");
//       return;
//     }
//     try {
//       setPlacing(true);
//       const payload = { serviceType, user, schedule, fields };
//       const { data } = await axios.post(`${URL}/admin/orders`, payload);
//       alert(`Order placed: ${data?.order?.order_number || ""}`);
//       setFields({});
//     } catch (e) {
//       console.error(e);
//       alert(
//         e?.response?.data?.message ||
//           e?.response?.data?.error ||
//           "Failed to place order"
//       );
//     } finally {
//       setPlacing(false);
//     }
//   };

//   // render one field row
//   const renderField = (f) => {
//     if (f.type === "number") {
//       const val = Number(fields[f.prop] || 0);
//       return (
//         <div className="apo-line" key={f.prop}>
//           <div className="apo-line-title">{f.prop.replaceAll("_", " ")}</div>
//           <NumberStepper
//             value={val}
//             onChange={(v) => setFields({ ...fields, [f.prop]: v })}
//           />
//           <div className="apo-line-unit">
//             {serviceType === "AC Service"
//               ? "per unit (tiered)"
//               : serviceType === "Home Cleaning" && MAP_HOME_FIRSTFREE[f.prop]
//               ? "first unit free"
//               : `৳${perUnitRate(serviceType, f.prop)} / unit`}
//           </div>
//         </div>
//       );
//     }
//     if (f.type === "boolean") {
//       return (
//         <div className="apo-line" key={f.prop}>
//           <div className="apo-line-title">{f.prop.replaceAll("_", " ")}</div>
//           <Form.Select
//             style={{ maxWidth: 200 }}
//             value={fields[f.prop] ? "yes" : "no"}
//             onChange={(e) =>
//               setFields({ ...fields, [f.prop]: e.target.value === "yes" })
//             }
//           >
//             <option value="no">No</option>
//             <option value="yes">Yes</option>
//           </Form.Select>
//           <div className="apo-line-unit">
//             {serviceType === "Electrician" &&
//               f.prop in ELEC_BOOL_FLAT &&
//               `Flat ৳${ALL_PRICING[serviceType][ELEC_BOOL_FLAT[f.prop]]}`}
//             {serviceType === "Plumber" &&
//               f.prop in PLUMBER_BOOL_FLAT &&
//               `Flat ৳${ALL_PRICING[serviceType][PLUMBER_BOOL_FLAT[f.prop]]}`}
//             {serviceType === "Gas Chula" &&
//               f.prop in GAS_BOOL_FLAT &&
//               `Flat ৳${ALL_PRICING[serviceType][GAS_BOOL_FLAT[f.prop]]}`}
//             {serviceType === "Filter" &&
//               f.prop in FILTER_BOOL_FLAT &&
//               `Flat ৳${ALL_PRICING[serviceType][FILTER_BOOL_FLAT[f.prop]]}`}
//           </div>
//         </div>
//       );
//     }
//     // text
//     return (
//       <Form.Group key={f.prop} className="mb-2">
//         <Form.Label>{f.prop.replaceAll("_", " ")}</Form.Label>
//         <Form.Control
//           value={fields[f.prop] || ""}
//           onChange={(e) => setFields({ ...fields, [f.prop]: e.target.value })}
//         />
//       </Form.Group>
//     );
//   };

//   const icon = SERVICE_ICONS[serviceType];

//   return (
//     <Container fluid className="apo-container">
//       <Card className="apo-card">
//         <Card.Header className="apo-header">
//           <div className="apo-header-left">
//             <div className="apo-service-icon">{icon}</div>
//             <div>
//               <h3 className="apo-title">Place Order (Admin)</h3>
//               <div className="apo-sub">Create a new {serviceType} order</div>
//             </div>
//           </div>
//           <div style={{ minWidth: 240 }}>
//             <Form.Select
//               value={serviceType}
//               onChange={(e) => {
//                 setServiceType(e.target.value);
//                 setFields({});
//               }}
//             >
//               {SERVICES.map((s) => (
//                 <option key={s}>{s}</option>
//               ))}
//             </Form.Select>
//           </div>
//         </Card.Header>

//         <Card.Body>
//           {/* Dynamic fields */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">
//                   Service Details
//                 </Card.Header>
//                 <Card.Body>
//                   <Row className="g-3">
//                     {(serviceFields[serviceType] || []).map((f) => (
//                       <Col md={6} lg={4} key={f.prop}>
//                         {renderField(f)}
//                       </Col>
//                     ))}
//                   </Row>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {/* Price */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">Price</Card.Header>
//                 <Card.Body>
//                   <Table bordered responsive>
//                     <tbody>
//                       <tr>
//                         <th>Subtotal</th>
//                         <td className="text-end">৳{pricing.subtotal}</td>
//                       </tr>
//                       <tr>
//                         <th>Discount</th>
//                         <td className="text-end">৳{pricing.discount}</td>
//                       </tr>
//                       <tr>
//                         <th>Total</th>
//                         <td className="text-end">
//                           <Badge bg="success" pill>
//                             ৳{pricing.total}
//                           </Badge>
//                         </td>
//                       </tr>
//                     </tbody>
//                   </Table>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {/* User & schedule */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">
//                   User & Schedule
//                 </Card.Header>
//                 <Card.Body>
//                   <Row className="g-3">
//                     {/* <Col md={4}>
//                       <Form.Label><FaPhone/> Mobile *</Form.Label>
//                       <Form.Control value={user.mobile} onChange={(e)=>setUser({...user, mobile: e.target.value.replace(/\s/g,'')})}/>
//                     </Col> */}

//                     <Col md={4}>
//                       <Form.Label>
//                         <FaPhone /> Mobile *
//                       </Form.Label>
//                       <div className="d-flex align-items-center gap-2">
//                         <Form.Control
//                           value={user.mobile}
//                           onChange={(e) =>
//                             setUser({
//                               ...user,
//                               mobile: e.target.value.replace(/\s/g, ""),
//                             })
//                           }
//                           placeholder="11-digit mobile"
//                           maxLength={11}
//                         />
//                         {lookingUp && <Spinner size="sm" animation="border" />}
//                       </div>
//                       {foundUser && (
//                         <div className="mt-1">
//                           <small className="text-success">
//                             Existing user found (ID: {foundUser.Id})
//                           </small>
//                         </div>
//                       )}
//                       {!foundUser &&
//                         /^\d{11}$/.test(user.mobile) &&
//                         !lookingUp && (
//                           <div className="mt-1">
//                             <small className="text-muted">
//                               New user — fill details below
//                             </small>
//                           </div>
//                         )}
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label>
//                         <FaUser /> First Name
//                       </Form.Label>
//                       <Form.Control
//                         value={user.FirstName}
//                         onChange={(e) =>
//                           setUser({ ...user, FirstName: e.target.value })
//                         }
//                       />
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Last Name</Form.Label>
//                       <Form.Control
//                         value={user.LastName}
//                         onChange={(e) =>
//                           setUser({ ...user, LastName: e.target.value })
//                         }
//                       />
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label>
//                         <FaMapMarkerAlt /> City *
//                       </Form.Label>
//                       <Form.Select
//                         value={user.city}
//                         onChange={(e) => {
//                           const name = e.target.value;
//                           const div =
//                             divisions.find((d) => d.name === name) || {};
//                           setUser({
//                             ...user,
//                             city: name,
//                             cityCode: div.code || "",
//                             area: "",
//                           });
//                         }}
//                       >
//                         <option value="">Select City</option>
//                         {divisions.map((d) => (
//                           <option key={d.name} value={d.name}>
//                             {d.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Area *</Form.Label>
//                       <Form.Select
//                         value={user.area}
//                         onChange={(e) =>
//                           setUser({ ...user, area: e.target.value })
//                         }
//                         disabled={!user.city}
//                       >
//                         <option value="">Select Area</option>
//                         {areas.map((a) => (
//                           <option key={a.name} value={a.name}>
//                             {a.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Address *</Form.Label>
//                       <Form.Control
//                         value={user.Address}
//                         onChange={(e) =>
//                           setUser({ ...user, Address: e.target.value })
//                         }
//                       />
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label>
//                         <FaCalendar /> Date *
//                       </Form.Label>
//                       <Form.Control
//                         type="date"
//                         min={todayISO()}
//                         value={schedule.date}
//                         onChange={(e) =>
//                           setSchedule({ ...schedule, date: e.target.value })
//                         }
//                       />
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Time *</Form.Label>
//                       <Form.Select
//                         value={schedule.time}
//                         onChange={(e) =>
//                           setSchedule({ ...schedule, time: e.target.value })
//                         }
//                       >
//                         <option value="">Select Time</option>
//                         {timeSlots.map((t) => (
//                           <option key={t}>{t}</option>
//                         ))}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4} className="d-flex align-items-end">
//                       <Button
//                         className="w-100"
//                         variant="success"
//                         disabled={!canSubmit || placing}
//                         onClick={place}
//                       >
//                         {placing ? (
//                           <>
//                             <Spinner
//                               size="sm"
//                               animation="border"
//                               className="me-2"
//                             />
//                             Placing…
//                           </>
//                         ) : (
//                           <>
//                             <FaClipboardCheck className="me-2" />
//                             Place Order
//                           </>
//                         )}
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// }










// import React, { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import {
//   Container, Card, Row, Col, Form, Button, Table, Badge, Spinner, OverlayTrigger, Tooltip
// } from "react-bootstrap";
// import {
//   FaBolt, FaBroom, FaCogs, FaFire, FaSnowflake, FaFilter as FaFilterIcon,
//   FaUser, FaPhone, FaMapMarkerAlt, FaCalendar, FaClipboardCheck, FaInfoCircle, FaCheck
// } from "react-icons/fa";
// import { URL } from "../../../config";

// // bring your shared maps
// import { serviceFields } from "../../Services/serviceFields";
// import SERVICE_PRICING, { SERVICE_PRICING as ALL_PRICING, AC_PRICING } from "../../Services/servicePricing";
// import "./AdminPlaceOrder.css";

// /* ---------- small helpers ---------- */
// const pad2 = (n)=>String(n).padStart(2,"0");
// const todayISO = ()=>{ const d=new Date(); return `${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())}`; };
// const generateSlots = ()=>{ const out=[]; for(let h=7; h<=21; h++){ for(let m=0;m<60;m+=30){ let dh=h%12; if(dh===0) dh=12; out.push(`${dh}:${pad2(m)} ${h<12?"AM":"PM"}`);} } return out; };

// /* ---------- pricing helpers (same as backend) ---------- */
// const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };
// const MAP_PLUMBER = {
//   angle_valve_setup:"angleValveSetup", basin_tap_setup:"basinTapSetup", magic_pipe_setup:"magicPipeSetup",
//   basin_waste_pop_up_setup:"bathroomShelfSetup" /* placeholder to keep map complete */,
//   new_basin_setup_existing_lines:"newBasinSetupExistingLines", bathroom_tap_bib_cock_setup:"bathroomTapBibCockSetup",
//   tissue_holder_setup:"tissueHolderSetup", fill_valve_replacement:"fillValveReplacement",
//   hand_shower_setup:"handShowerSetup", soap_dish_setup:"soapDishSetup", bathroom_shelf_setup:"bathroomShelfSetup",
//   mirror_setup:"mirrorSetup", towel_hanger_setup:"towelHangerSetup", shower_head_setup:"showerHeadSetup",
//   concealed_stopcock_setup:"conceledStopcockSetup", floor_drain_net_setup:"floorDrainNetSetup",
//   toilet_seat_cover_replacement:"toiletSeatCoverReplacement", toilet_seat_complete_installation:"toiletSeatCompleteInstallation",
//   high_commode_installation_existing_lines:"highCommodeInstallationExistingLines", blockage_clearing_high_commode:"blockageClearingHighCommode",
//   blockage_clearing_low_commode:"blockageClearingLowCommode", bathroom_drain_line_cleaning:"bathroomDrainLineCleaning",
//   geyser_installation:"geyserInstallation", kitchen_sink_setup_existing_lines:"kitchenSinkSetupExistingLines",
//   sink_blockage_cleaning:"sinkBlockageCleaning", washing_machine_point_setup:"washingMachinePointSetup"
// };
// const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };
// const MAP_GAS = { NewchulaSetup:"newChulaSetup", chulaSetup:"chulaSetup", burnerSetup:"burnerSetup", burnerCleaning:"burnerCleaning", nozzleReplacement:"nozzleReplacement" };
// const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };
// const MAP_FILTER = { new_filter_setup:"newFilterSetup", installation_filter:"installationFilter", uninstallation_filter:"uninstallationFilter", kit_replacement:"kitReplacement", pipe_leak_or_replace:"pipeLeakOrReplace", full_servicing:"fullServicing" };
// const FILTER_BOOL_FLAT = { check_up:"checkupFlat" };
// const MAP_HOME_FIRSTFREE = { bed:"bedrooms", kitchen:"kitchens", dra_din:"drawingdinning" };
// const MAP_HOME_PERUNIT = { bath:"bathrooms", cloth:"cloths", dish:"dishes", balcony:"balconies", window_grill:"windowGrills", furniture_cleaning:"furniture", stairs_and_railing:"stairsFloors", carpet_cleaning:"carpets" };
// const AC_NUMERIC_PROPS = new Set(["installation_outdoor_inside","installation_outdoor_outside","uninstallation_outdoor_inside","uninstallation_outdoor_outside","cleaning_outdoor_inside","cleaning_outdoor_outside"]);
// const AC_CHECKUP_KEY = "issue_checkup";

// const acTierTotal = (prop, qty)=>{
//   const c=Math.max(0,Number(qty)||0); if(!c) return 0;
//   const rate=AC_PRICING?.perUnit?.[prop]; if(!rate) return 0;
//   return c===1? rate.first : c*rate.additional;
// };
// const acCheckupTotal = (qty)=>{
//   const c=Math.max(0,Number(qty)||0); if(!c) return 0;
//   const { base=0, includesUnits=0, extraPerUnit=0 }=AC_PRICING?.checkup||{};
//   return c<=includesUnits? base : base + (c-includesUnits)*extraPerUnit;
// };

// /* ---------- per-unit lookup for non-AC/HC ---------- */
// function perUnitRate(service, prop) {
//   const pricing = ALL_PRICING[service];
//   if (!pricing) return 0;
//   if (service === "Electrician") return Number(pricing.perUnit?.[prop] || 0);
//   if (service === "Plumber")   return Number(pricing.perUnit?.[MAP_PLUMBER[prop]] || 0);
//   if (service === "Gas Chula") return Number(pricing.perUnit?.[MAP_GAS[prop]] || 0);
//   if (service === "Filter")    return Number(pricing.perUnit?.[MAP_FILTER[prop]] || 0);
//   if (service === "Home Cleaning") return Number(pricing.perUnit?.[MAP_HOME_PERUNIT[prop]] || 0);
//   return 0;
// }

// const SERVICE_ICONS = {
//   "Electrician": <FaBolt/>, "Home Cleaning": <FaBroom/>, "Plumber": <FaCogs/>, "Gas Chula": <FaFire/>, "AC Service": <FaSnowflake/>, "Filter": <FaFilterIcon/>, "Tutor Service": <FaUser/>
// };
// const SERVICES = Object.keys(serviceFields);

// /* =========================
//    Fancy field components
//    ========================= */
// function InfoTip({ text }) {
//   if (!text) return null;
//   return (
//     <OverlayTrigger placement="top" overlay={<Tooltip id="tt">{text}</Tooltip>}>
//       <span className="apo-info"><FaInfoCircle/></span>
//     </OverlayTrigger>
//   );
// }

// function NumberCard({ title, value=0, onChange, unit="units", hint }) {
//   return (
//     <div className="sf-card">
//       <div className="sf-card-head">
//         <div className="sf-title">{title}</div>
//         <InfoTip text={hint}/>
//       </div>

//       <div className="sf-stepper">
//         <button
//           type="button"
//           className="sf-stepper-btn sf-minus"
//           aria-label={`Decrease ${title}`}
//           onClick={()=>onChange(Math.max(0, value-1))}
//         >−</button>

//         <div className="sf-stepper-center">
//           <div className="sf-stepper-value">{value}</div>
//           <div className="sf-stepper-unit">{unit}</div>
//         </div>

//         <button
//           type="button"
//           className="sf-stepper-btn sf-plus"
//           aria-label={`Increase ${title}`}
//           onClick={()=>onChange(value+1)}
//         >+</button>
//       </div>
//     </div>
//   );
// }

// function ToggleCard({ title, checked=false, onChange, priceNote, hint }) {
//   return (
//     <div className="sf-card">
//       <div className="sf-card-head">
//         <div className="sf-title">{title}</div>
//         <InfoTip text={hint}/>
//       </div>

//       <div className="sf-toggle">
//         <button
//           type="button"
//           className={`sf-toggle-btn ${checked ? "on" : ""}`}
//           onClick={()=>onChange(!checked)}
//           aria-pressed={checked}
//         >
//           <span className="sf-toggle-knob">{checked && <FaCheck/>}</span>
//           <span className="sf-toggle-label">{checked ? "Yes" : "No"}</span>
//         </button>
//         {priceNote && <div className="sf-price-note">{priceNote}</div>}
//       </div>
//     </div>
//   );
// }

// function TextFieldCard({ title, value, onChange, placeholder, hint }) {
//   return (
//     <div className="sf-card">
//       <div className="sf-card-head">
//         <div className="sf-title">{title}</div>
//         <InfoTip text={hint}/>
//       </div>
//       <Form.Control
//         className="sf-input"
//         value={value || ""}
//         placeholder={placeholder || ""}
//         onChange={(e)=>onChange(e.target.value)}
//       />
//     </div>
//   );
// }

// /* =========================
//    Main Component
//    ========================= */
// export default function AdminPlaceOrder() {
//   const [serviceType, setServiceType] = useState("Electrician");
//   const [fields, setFields] = useState({});
//   const [user, setUser] = useState({ mobile:"", FirstName:"", LastName:"", city:"", cityCode:"", area:"", Address:"" });
//   const [schedule, setSchedule] = useState({ date: todayISO(), time:"" });
//   const [divisions, setDivisions] = useState([]);
//   const [areas, setAreas] = useState([]);
//   const [placing, setPlacing] = useState(false);

//   const timeSlots = useMemo(()=>generateSlots(), []);

//   const [foundUser, setFoundUser] = useState(null);
//   const [lookingUp, setLookingUp] = useState(false);

//   const debounce = (fn, delay=400) => {
//     let t;
//     return (...args) => { clearTimeout(t); t = setTimeout(()=>fn(...args), delay); };
//   };

//   const doLookup = useMemo(() => debounce(async (m) => {
//     if (!/^\d{11}$/.test(m)) { setFoundUser(null); return; }
//     try {
//       setLookingUp(true);
//       const { data } = await axios.get(`${URL}/admin/users/lookup`, { params: { mobile: m } });
//       setFoundUser(data);
//       if (data) {
//         setUser(prev => ({
//           ...prev,
//           mobile: data.mobile || m,
//           FirstName: data.FirstName || "",
//           LastName:  data.LastName  || "",
//           city:      data.city      || "",
//           area:      data.area      || "",
//           Address:   data.Address   || "",
//           userId:    data.Id        || ""
//         }));
//       } else {
//         setUser(prev => ({
//           ...prev, mobile: m, FirstName: "", LastName: "", city: "", area: "", Address: "", userId: ""
//         }));
//       }
//     } catch (e) {
//       console.error(e);
//       setFoundUser(null);
//     } finally {
//       setLookingUp(false);
//     }
//   }, 450), []);

//   useEffect(() => {
//     const m = (user.mobile || "").replace(/\s/g,"");
//     if (m.length === 11) doLookup(m);
//     else setFoundUser(null);
//   }, [user.mobile, doLookup]);

//   // Divisions
//   useEffect(()=>{
//     (async ()=>{
//       try{
//         const { data } = await axios.get(`${URL}/locations/divisions`);
//         const rows = Array.isArray(data)
//           ? data.map(d=>({ name: d.name||d.division||d.title, code: d.code||d.Code||d.id||d.Id }))
//           : [];
//         setDivisions(rows);
//       }catch(e){ console.error(e); }
//     })();
//   },[]);

//   // Areas for division
//   useEffect(()=>{
//     (async ()=>{
//       if (!user.city && !user.cityCode) { setAreas([]); return; }
//       try{
//         const params = user.cityCode ? { divisionCode: user.cityCode } : { division: user.city };
//         const { data } = await axios.get(`${URL}/locations/areas`, { params });
//         const rows = Array.isArray(data) ? data.map(a=>({ name: a.name||a.area||a.title })) : [];
//         setAreas(rows);
//       }catch(e){ console.error(e); setAreas([]); }
//     })();
//   },[user.city, user.cityCode]);

//   // live pricing (mirrors backend)
//   const pricing = useMemo(()=>{
//     const p = SERVICE_PRICING[serviceType];
//     if (!p) return { subtotal: 0, discount: 0, total: 0 };
//     let sum = p.base ? Number(p.base) : 0;

//     if (serviceType === "AC Service") {
//       Object.keys(fields||{}).forEach(prop=>{
//         if (AC_NUMERIC_PROPS.has(prop)) sum += acTierTotal(prop, fields[prop]);
//       });
//       if (fields[AC_CHECKUP_KEY]) sum += acCheckupTotal(fields[AC_CHECKUP_KEY]);
//       return { subtotal: Math.round(sum), discount: 0, total: Math.round(sum) };
//     }

//     if (serviceType === "Home Cleaning") {
//       Object.entries(MAP_HOME_FIRSTFREE).forEach(([fprop, priceKey])=>{
//         const c = Math.max(0, Number(fields[fprop]||0));
//         const perAdd = p.firstFree?.[priceKey]?.perAdditional || 0;
//         if (c > 1) sum += (c-1) * perAdd;
//       });
//       Object.entries(MAP_HOME_PERUNIT).forEach(([fprop, priceKey])=>{
//         const c = Math.max(0, Number(fields[fprop]||0));
//         const rate = p.perUnit?.[priceKey] || 0;
//         sum += c * rate;
//       });
//       return { subtotal: Math.round(sum), discount: 0, total: Math.round(sum) };
//     }

//     (serviceFields[serviceType]||[]).forEach(f=>{
//       if (f.type === "number") {
//         const c = Math.max(0, Number(fields[f.prop]||0));
//         sum += c * perUnitRate(serviceType, f.prop);
//       } else if (f.type === "boolean") {
//         const yes = !!fields[f.prop];
//         if (serviceType === "Electrician" && f.prop in ELEC_BOOL_FLAT && yes) sum += p[ELEC_BOOL_FLAT[f.prop]] || 0;
//         if (serviceType === "Plumber"     && f.prop in PLUMBER_BOOL_FLAT && yes) sum += p[PLUMBER_BOOL_FLAT[f.prop]] || 0;
//         if (serviceType === "Gas Chula"   && f.prop in GAS_BOOL_FLAT && yes)     sum += p[GAS_BOOL_FLAT[f.prop]] || 0;
//         if (serviceType === "Filter"      && f.prop in FILTER_BOOL_FLAT && yes)  sum += p[FILTER_BOOL_FLAT[f.prop]] || 0;
//       }
//     });

//     return { subtotal: Math.round(sum), discount: 0, total: Math.round(sum) };
//   }, [serviceType, fields]);

//   const canSubmit =
//     user.mobile && user.city && user.area && user.Address &&
//     schedule.date && schedule.time;

//   const place = async ()=>{
//     if (!canSubmit) { alert("Fill all required fields."); return; }
//     try{
//       setPlacing(true);
//       const payload = { serviceType, user, schedule, fields };
//       const { data } = await axios.post(`${URL}/admin/orders`, payload);
//       alert(`Order placed: ${data?.order?.order_number || ""}`);
//       setFields({});
//     }catch(e){
//       console.error(e);
//       alert(e?.response?.data?.message || e?.response?.data?.error || "Failed to place order");
//     }finally{
//       setPlacing(false);
//     }
//   };

//   /* Render each field as a “card” */
//   const renderField = (f) => {
//     const title = f.prop.replaceAll("_"," ").replace(/\b\w/g, c => c.toUpperCase());
//     const perUnit = perUnitRate(serviceType, f.prop);
//     const hint = f.type === "number"
//       ? (serviceType==="AC Service" ? "Tiered pricing by unit" :
//          serviceType==="Home Cleaning" && MAP_HOME_FIRSTFREE[f.prop] ? "First unit free" :
//          perUnit ? `৳${perUnit} per unit` : undefined)
//       : (f.type === "boolean" ? "Enable if needed" : undefined);

//     if (f.type === "number") {
//       const val = Number(fields[f.prop] || 0);
//       return (
//         <Col md={6} lg={4} key={f.prop}>
//           <NumberCard
//             title={title}
//             value={val}
//             onChange={(v)=>setFields({...fields, [f.prop]: v})}
//             unit="units"
//             hint={hint}
//           />
//         </Col>
//       );
//     }

//     if (f.type === "boolean") {
//       const checked = !!fields[f.prop];
//       const priceNote =
//         serviceType==="Electrician" && (f.prop in ELEC_BOOL_FLAT) ? `Flat ৳${ALL_PRICING[serviceType][ELEC_BOOL_FLAT[f.prop]]}` :
//         serviceType==="Plumber"    && (f.prop in PLUMBER_BOOL_FLAT) ? `Flat ৳${ALL_PRICING[serviceType][PLUMBER_BOOL_FLAT[f.prop]]}` :
//         serviceType==="Gas Chula"  && (f.prop in GAS_BOOL_FLAT) ?    `Flat ৳${ALL_PRICING[serviceType][GAS_BOOL_FLAT[f.prop]]}` :
//         serviceType==="Filter"     && (f.prop in FILTER_BOOL_FLAT) ? `Flat ৳${ALL_PRICING[serviceType][FILTER_BOOL_FLAT[f.prop]]}` :
//         undefined;

//       return (
//         <Col md={6} lg={4} key={f.prop}>
//           <ToggleCard
//             title={title}
//             checked={checked}
//             onChange={(v)=>setFields({...fields, [f.prop]: v})}
//             priceNote={priceNote}
//             hint={hint}
//           />
//         </Col>
//       );
//     }

//     // text
//     return (
//       <Col md={6} lg={4} key={f.prop}>
//         <TextFieldCard
//           title={title}
//           value={fields[f.prop]}
//           onChange={(v)=>setFields({...fields, [f.prop]: v})}
//           placeholder="Type here"
//           hint={hint}
//         />
//       </Col>
//     );
//   };

//   const icon = SERVICE_ICONS[serviceType];

//   return (
//     <Container fluid className="apo-container">
//       <Card className="apo-card">
//         <Card.Header className="apo-header">
//           <div className="apo-header-left">
//             <div className="apo-service-icon">{icon}</div>
//             <div>
//               <h3 className="apo-title">Place Order (Admin)</h3>
//               <div className="apo-sub">Create a new {serviceType} order</div>
//             </div>
//           </div>
//           <div style={{minWidth:240}}>
//             <Form.Select
//               value={serviceType}
//               onChange={(e)=>{ setServiceType(e.target.value); setFields({}); }}
//             >
//               {SERVICES.map(s=><option key={s}>{s}</option>)}
//             </Form.Select>
//           </div>
//         </Card.Header>

//         <Card.Body>
//           {/* Service fields */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">Service Details</Card.Header>
//                 <Card.Body>
//                   <Row className="g-3">
//                     {(serviceFields[serviceType]||[]).map(renderField)}
//                   </Row>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {/* Price */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">Price</Card.Header>
//                 <Card.Body>
//                   <Table bordered responsive>
//                     <tbody>
//                       <tr><th>Subtotal</th><td className="text-end">৳{pricing.subtotal}</td></tr>
//                       <tr><th>Discount</th><td className="text-end">৳{pricing.discount}</td></tr>
//                       <tr><th>Total</th><td className="text-end"><Badge bg="success" pill>৳{pricing.total}</Badge></td></tr>
//                     </tbody>
//                   </Table>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {/* User & schedule */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">User & Schedule</Card.Header>
//                 <Card.Body>
//                   <Row className="g-3">
//                     <Col md={4}>
//                       <Form.Label><FaPhone/> Mobile *</Form.Label>
//                       <div className="d-flex align-items-center gap-2">
//                         <Form.Control
//                           value={user.mobile}
//                           onChange={(e)=>setUser({...user, mobile: e.target.value.replace(/\s/g,'')})}
//                           placeholder="11-digit mobile"
//                           maxLength={11}
//                         />
//                         {lookingUp && <Spinner size="sm" animation="border" />}
//                       </div>
//                       {foundUser && (
//                         <div className="mt-1">
//                           <small className="text-success">Existing user found (ID: {foundUser.Id})</small>
//                         </div>
//                       )}
//                       {!foundUser && /^\d{11}$/.test(user.mobile) && !lookingUp && (
//                         <div className="mt-1">
//                           <small className="text-muted">New user — fill details below</small>
//                         </div>
//                       )}
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label><FaUser/> First Name</Form.Label>
//                       <Form.Control value={user.FirstName} onChange={(e)=>setUser({...user, FirstName: e.target.value})}/>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Last Name</Form.Label>
//                       <Form.Control value={user.LastName} onChange={(e)=>setUser({...user, LastName: e.target.value})}/>
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label><FaMapMarkerAlt/> City *</Form.Label>
//                       <Form.Select
//                         value={user.city}
//                         onChange={(e)=>{
//                           const name = e.target.value;
//                           const div = divisions.find(d=>d.name===name) || {};
//                           setUser({...user, city: name, cityCode: div.code || "", area:""});
//                         }}
//                       >
//                         <option value="">Select City</option>
//                         {divisions.map(d=><option key={d.name} value={d.name}>{d.name}</option>)}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Area *</Form.Label>
//                       <Form.Select
//                         value={user.area}
//                         onChange={(e)=>setUser({...user, area: e.target.value})}
//                         disabled={!user.city}
//                       >
//                         <option value="">Select Area</option>
//                         {areas.map(a=><option key={a.name} value={a.name}>{a.name}</option>)}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Address *</Form.Label>
//                       <Form.Control value={user.Address} onChange={(e)=>setUser({...user, Address: e.target.value})}/>
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label><FaCalendar/> Date *</Form.Label>
//                       <Form.Control type="date" min={todayISO()} value={schedule.date} onChange={(e)=>setSchedule({...schedule, date: e.target.value})}/>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Time *</Form.Label>
//                       <Form.Select value={schedule.time} onChange={(e)=>setSchedule({...schedule, time: e.target.value})}>
//                         <option value="">Select Time</option>
//                         {timeSlots.map(t=><option key={t}>{t}</option>)}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4} className="d-flex align-items-end">
//                       <Button className="w-100" variant="success" disabled={!canSubmit || placing} onClick={place}>
//                         {placing ? <><Spinner size="sm" animation="border" className="me-2" />Placing…</> : <><FaClipboardCheck className="me-2"/>Place Order</>}
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// }






// import React, { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import {
//   Container, Card, Row, Col, Form, Button, Table, Badge, Spinner, OverlayTrigger, Tooltip
// } from "react-bootstrap";
// import {
//   FaBolt, FaBroom, FaCogs, FaFire, FaSnowflake, FaFilter as FaFilterIcon,
//   FaUser, FaPhone, FaMapMarkerAlt, FaCalendar, FaClipboardCheck, FaInfoCircle, FaCheck
// } from "react-icons/fa";
// import { URL } from "../../../config";

// // bring your shared maps
// import { serviceFields } from "../../Services/serviceFields";
// import SERVICE_PRICING, { SERVICE_PRICING as ALL_PRICING, AC_PRICING } from "../../Services/servicePricing";
// import "./AdminPlaceOrder.css";

// /* ---------- small helpers ---------- */
// const pad2 = (n)=>String(n).padStart(2,"0");
// const todayISO = ()=>{ const d=new Date(); return `${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())}`; };
// const generateSlots = ()=>{ const out=[]; for(let h=7; h<=21; h++){ for(let m=0;m<60;m+=30){ let dh=h%12; if(dh===0) dh=12; out.push(`${dh}:${pad2(m)} ${h<12?"AM":"PM"}`);} } return out; };

// /* ---------- pricing helpers (same as backend) ---------- */
// const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };
// const MAP_PLUMBER = {
//   angle_valve_setup:"angleValveSetup", basin_tap_setup:"basinTapSetup", magic_pipe_setup:"magicPipeSetup",
//   basin_waste_pop_up_setup:"bathroomShelfSetup" /* placeholder to keep map complete */,
//   new_basin_setup_existing_lines:"newBasinSetupExistingLines", bathroom_tap_bib_cock_setup:"bathroomTapBibCockSetup",
//   tissue_holder_setup:"tissueHolderSetup", fill_valve_replacement:"fillValveReplacement",
//   hand_shower_setup:"handShowerSetup", soap_dish_setup:"soapDishSetup", bathroom_shelf_setup:"bathroomShelfSetup",
//   mirror_setup:"mirrorSetup", towel_hanger_setup:"towelHangerSetup", shower_head_setup:"showerHeadSetup",
//   concealed_stopcock_setup:"conceledStopcockSetup", floor_drain_net_setup:"floorDrainNetSetup",
//   toilet_seat_cover_replacement:"toiletSeatCoverReplacement", toilet_seat_complete_installation:"toiletSeatCompleteInstallation",
//   high_commode_installation_existing_lines:"highCommodeInstallationExistingLines", blockage_clearing_high_commode:"blockageClearingHighCommode",
//   blockage_clearing_low_commode:"blockageClearingLowCommode", bathroom_drain_line_cleaning:"bathroomDrainLineCleaning",
//   geyser_installation:"geyserInstallation", kitchen_sink_setup_existing_lines:"kitchenSinkSetupExistingLines",
//   sink_blockage_cleaning:"sinkBlockageCleaning", washing_machine_point_setup:"washingMachinePointSetup"
// };
// const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };
// const MAP_GAS = { NewchulaSetup:"newChulaSetup", chulaSetup:"chulaSetup", burnerSetup:"burnerSetup", burnerCleaning:"burnerCleaning", nozzleReplacement:"nozzleReplacement" };
// const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };
// const MAP_FILTER = { new_filter_setup:"newFilterSetup", installation_filter:"installationFilter", uninstallation_filter:"uninstallationFilter", kit_replacement:"kitReplacement", pipe_leak_or_replace:"pipeLeakOrReplace", full_servicing:"fullServicing" };
// const FILTER_BOOL_FLAT = { check_up:"checkupFlat" };
// const MAP_HOME_FIRSTFREE = { bed:"bedrooms", kitchen:"kitchens", dra_din:"drawingdinning" };
// const MAP_HOME_PERUNIT = { bath:"bathrooms", cloth:"cloths", dish:"dishes", balcony:"balconies", window_grill:"windowGrills", furniture_cleaning:"furniture", stairs_and_railing:"stairsFloors", carpet_cleaning:"carpets" };
// const AC_NUMERIC_PROPS = new Set(["installation_outdoor_inside","installation_outdoor_outside","uninstallation_outdoor_inside","uninstallation_outdoor_outside","cleaning_outdoor_inside","cleaning_outdoor_outside"]);
// const AC_CHECKUP_KEY = "issue_checkup";

// const acTierTotal = (prop, qty)=>{
//   const c=Math.max(0,Number(qty)||0); if(!c) return 0;
//   const rate=AC_PRICING?.perUnit?.[prop]; if(!rate) return 0;
//   return c===1? rate.first : c*rate.additional;
// };
// const acCheckupTotal = (qty)=>{
//   const c=Math.max(0,Number(qty)||0); if(!c) return 0;
//   const { base=0, includesUnits=0, extraPerUnit=0 }=AC_PRICING?.checkup||{};
//   return c<=includesUnits? base : base + (c-includesUnits)*extraPerUnit;
// };

// /* ---------- per-unit lookup for non-AC/HC ---------- */
// function perUnitRate(service, prop) {
//   const pricing = ALL_PRICING[service];
//   if (!pricing) return 0;
//   if (service === "Electrician") return Number(pricing.perUnit?.[prop] || 0);
//   if (service === "Plumber")   return Number(pricing.perUnit?.[MAP_PLUMBER[prop]] || 0);
//   if (service === "Gas Chula") return Number(pricing.perUnit?.[MAP_GAS[prop]] || 0);
//   if (service === "Filter")    return Number(pricing.perUnit?.[MAP_FILTER[prop]] || 0);
//   if (service === "Home Cleaning") return Number(pricing.perUnit?.[MAP_HOME_PERUNIT[prop]] || 0);
//   return 0;
// }

// const SERVICE_ICONS = {
//   "Electrician": <FaBolt/>, "Home Cleaning": <FaBroom/>, "Plumber": <FaCogs/>, "Gas Chula": <FaFire/>, "AC Service": <FaSnowflake/>, "Filter": <FaFilterIcon/>, "Tutor Service": <FaUser/>
// };
// const SERVICES = Object.keys(serviceFields);

// /* =========================
//    Fancy field components
//    ========================= */
// function InfoTip({ text }) {
//   if (!text) return null;
//   return (
//     <OverlayTrigger placement="top" overlay={<Tooltip id="tt">{text}</Tooltip>}>
//       <span className="apo-info"><FaInfoCircle/></span>
//     </OverlayTrigger>
//   );
// }

// function NumberCard({ title, value=0, onChange, unit="units", hint }) {
//   return (
//     <div className="sf-card">
//       <div className="sf-card-head">
//         <div className="sf-title">{title}</div>
//         <InfoTip text={hint}/>
//       </div>

//       <div className="sf-stepper">
//         <button
//           type="button"
//           className="sf-stepper-btn sf-minus"
//           aria-label={`Decrease ${title}`}
//           onClick={()=>onChange(Math.max(0, value-1))}
//         >−</button>

//         <div className="sf-stepper-center">
//           <div className="sf-stepper-value">{value}</div>
//           <div className="sf-stepper-unit">{unit}</div>
//         </div>

//         <button
//           type="button"
//           className="sf-stepper-btn sf-plus"
//           aria-label={`Increase ${title}`}
//           onClick={()=>onChange(value+1)}
//         >+</button>
//       </div>
//     </div>
//   );
// }

// function ToggleCard({ title, checked=false, onChange, priceNote, hint }) {
//   return (
//     <div className="sf-card">
//       <div className="sf-card-head">
//         <div className="sf-title">{title}</div>
//         <InfoTip text={hint}/>
//       </div>

//       <div className="sf-toggle">
//         <button
//           type="button"
//           className={`sf-toggle-btn ${checked ? "on" : ""}`}
//           onClick={()=>onChange(!checked)}
//           aria-pressed={checked}
//         >
//           <span className="sf-toggle-knob">{checked && <FaCheck/>}</span>
//           <span className="sf-toggle-label">{checked ? "Yes" : "No"}</span>
//         </button>
//         {priceNote && <div className="sf-price-note">{priceNote}</div>}
//       </div>
//     </div>
//   );
// }

// function TextFieldCard({ title, value, onChange, placeholder, hint }) {
//   return (
//     <div className="sf-card">
//       <div className="sf-card-head">
//         <div className="sf-title">{title}</div>
//         <InfoTip text={hint}/>
//       </div>
//       <Form.Control
//         className="sf-input"
//         value={value || ""}
//         placeholder={placeholder || ""}
//         onChange={(e)=>onChange(e.target.value)}
//       />
//     </div>
//   );
// }

// /* =========================
//    Main Component
//    ========================= */
// export default function AdminPlaceOrder() {
//   const [serviceType, setServiceType] = useState("Electrician");
//   const [fields, setFields] = useState({});
//   const [user, setUser] = useState({ mobile:"", FirstName:"", LastName:"", city:"", cityCode:"", area:"", Address:"" });
//   const [schedule, setSchedule] = useState({ date: todayISO(), time:"" });
//   const [divisions, setDivisions] = useState([]);
//   const [areas, setAreas] = useState([]);
//   const [placing, setPlacing] = useState(false);

//   const timeSlots = useMemo(()=>generateSlots(), []);

//   const [foundUser, setFoundUser] = useState(null);
//   const [lookingUp, setLookingUp] = useState(false);

//   // UPDATED: discount state (no note)
//   const [discountValue, setDiscountValue] = useState(0); // UPDATED

//   const debounce = (fn, delay=400) => {
//     let t;
//     return (...args) => { clearTimeout(t); t = setTimeout(()=>fn(...args), delay); };
//   };

//   const doLookup = useMemo(() => debounce(async (m) => {
//     if (!/^\d{11}$/.test(m)) { setFoundUser(null); return; }
//     try {
//       setLookingUp(true);
//       const { data } = await axios.get(`${URL}/admin/users/lookup`, { params: { mobile: m } });
//       setFoundUser(data);
//       if (data) {
//         setUser(prev => ({
//           ...prev,
//           mobile: data.mobile || m,
//           FirstName: data.FirstName || "",
//           LastName:  data.LastName  || "",
//           city:      data.city      || "",
//           area:      data.area      || "",
//           Address:   data.Address   || "",
//           userId:    data.Id        || ""
//         }));
//       } else {
//         setUser(prev => ({
//           ...prev, mobile: m, FirstName: "", LastName: "", city: "", area: "", Address: "", userId: ""
//         }));
//       }
//     } catch (e) {
//       console.error(e);
//       setFoundUser(null);
//     } finally {
//       setLookingUp(false);
//     }
//   }, 450), []);

//   useEffect(() => {
//     const m = (user.mobile || "").replace(/\s/g,"");
//     if (m.length === 11) doLookup(m);
//     else setFoundUser(null);
//   }, [user.mobile, doLookup]);

//   // Divisions
//   useEffect(()=>{
//     (async ()=>{
//       try{
//         const { data } = await axios.get(`${URL}/locations/divisions`);
//         const rows = Array.isArray(data)
//           ? data.map(d=>({ name: d.name||d.division||d.title, code: d.code||d.Code||d.id||d.Id }))
//           : [];
//         setDivisions(rows);
//       }catch(e){ console.error(e); }
//     })();
//   },[]);

//   // Areas for division
//   useEffect(()=>{
//     (async ()=>{
//       if (!user.city && !user.cityCode) { setAreas([]); return; }
//       try{
//         const params = user.cityCode ? { divisionCode: user.cityCode } : { division: user.city };
//         const { data } = await axios.get(`${URL}/locations/areas`, { params });
//         const rows = Array.isArray(data) ? data.map(a=>({ name: a.name||a.area||a.title })) : [];
//         setAreas(rows);
//       }catch(e){ console.error(e); setAreas([]); }
//     })();
//   },[user.city, user.cityCode]);

//   // UPDATED: helper to decide if any selection was made (controls showing base fee)
//   const hasAnySelection = useMemo(()=>{
//     const defs = serviceFields[serviceType] || [];
//     for (const f of defs) {
//       if (f.type === "number" && Number(fields[f.prop] || 0) > 0) return true;
//       if (f.type === "boolean" && !!fields[f.prop]) return true;
//     }
//     return false;
//   }, [serviceType, fields]); // UPDATED

//   // UPDATED: pricing + breakdown (mirrors backend), applies discountValue
//   const pricing = useMemo(()=>{
//     const P = SERVICE_PRICING[serviceType];
//     if (!P) return { subtotal: 0, discount: 0, total: 0, breakdownRows: [] };

//     const rows = [];
//     const fmtTk = (n) => `৳${(Number(n) || 0).toLocaleString()}`;
//     const U = (v) => Math.max(0, Number(v) || 0);

//     let subtotal = 0;

//     // AC Service
//     if (serviceType === "AC Service") {
//       const addTierRow = (label, key) => {
//         const c = U(fields[key]);
//         if (!c) return;
//         const pk = AC_PRICING?.perUnit?.[key];
//         if (!pk) return;
//         const unitPrice = c === 1 ? pk.first : pk.additional;
//         const total = c === 1 ? pk.first : c * pk.additional;
//         rows.push({ label, calc: `${c} × ${fmtTk(unitPrice)} =`, total: fmtTk(total) });
//         subtotal += total;
//       };

//       addTierRow("Install (Outdoor Inside)",  "installation_outdoor_inside");
//       addTierRow("Install (Outdoor Outside)", "installation_outdoor_outside");
//       addTierRow("Uninstall (Outdoor Inside)",  "uninstallation_outdoor_inside");
//       addTierRow("Uninstall (Outdoor Outside)", "uninstallation_outdoor_outside");
//       addTierRow("Cleaning (Outdoor Inside)",  "cleaning_outdoor_inside");
//       addTierRow("Cleaning (Outdoor Outside)", "cleaning_outdoor_outside");

//       const c = U(fields[AC_CHECKUP_KEY]);
//       if (c > 0) {
//         const { base = 0, includesUnits = 0, extraPerUnit = 0 } = AC_PRICING?.checkup || {};
//         if (c <= includesUnits) {
//           rows.push({ label: "Issue Checkup", calc: `${c} units — ${fmtTk(base)}`, total: fmtTk(base) });
//           subtotal += base;
//         } else {
//           const extra = c - includesUnits;
//           const t = base + extra * extraPerUnit;
//           rows.push({ label: "Issue Checkup", calc: `${includesUnits} units — ${fmtTk(base)} + ${extra} × ${fmtTk(extraPerUnit)} =`, total: fmtTk(t) });
//           subtotal += t;
//         }
//       }

//       if (hasAnySelection && P.base > 0) {
//         rows.push({ label: "Booking Fee", calc: "", total: fmtTk(P.base) });
//         subtotal += Number(P.base) || 0;
//       }

//       const discount = Math.max(0, Number(discountValue) || 0);
//       const total = Math.max(0, subtotal - discount);
//       return { subtotal: Math.round(subtotal), discount, total: Math.round(total), breakdownRows: rows };
//     }

//     // Home Cleaning
//     if (serviceType === "Home Cleaning") {
//       Object.entries(MAP_HOME_FIRSTFREE).forEach(([fprop, priceKey])=>{
//         const c = U(fields[fprop]);
//         if (!c) return;
//         const perAdd = P.firstFree?.[priceKey]?.perAdditional || 0;
//         const qtyPaid = Math.max(0, c - 1);
//         if (qtyPaid > 0) {
//           const total = qtyPaid * perAdd;
//           rows.push({ label: `${fprop.replaceAll("_"," ")} (after first)`, calc: `${qtyPaid} × ${fmtTk(perAdd)} =`, total: fmtTk(total) });
//           subtotal += total;
//         } else {
//           rows.push({ label: `${fprop.replaceAll("_"," ")} (first free)`, calc: "", total: fmtTk(0) });
//         }
//       });
//       Object.entries(MAP_HOME_PERUNIT).forEach(([fprop, priceKey])=>{
//         const c = U(fields[fprop]);
//         if (!c) return;
//         const rate = Number(P.perUnit?.[priceKey] || 0);
//         const total = c * rate;
//         rows.push({ label: fprop.replaceAll("_"," "), calc: `${c} × ${fmtTk(rate)} =`, total: fmtTk(total) });
//         subtotal += total;
//       });

//       if (hasAnySelection && P.base > 0) {
//         rows.push({ label: "Booking Fee", calc: "", total: fmtTk(P.base) });
//         subtotal += Number(P.base) || 0;
//       }

//       const discount = Math.max(0, Number(discountValue) || 0);
//       const total = Math.max(0, subtotal - discount);
//       return { subtotal: Math.round(subtotal), discount, total: Math.round(total), breakdownRows: rows };
//     }

//     // Generic services (Electrician, Plumber, Gas Chula, Filter, Tutor)
//     (serviceFields[serviceType] || []).forEach((f) => {
//       if (f.type === "number") {
//         const c = U(fields[f.prop]);
//         if (!c) return;
//         const rate = perUnitRate(serviceType, f.prop);
//         const total = c * rate;
//         rows.push({ label: f.prop.replaceAll("_", " "), calc: `${c} × ${fmtTk(rate)} =`, total: fmtTk(total) });
//         subtotal += total;
//       } else if (f.type === "boolean" && !!fields[f.prop]) {
//         let flat = 0;
//         if (serviceType === "Electrician" && f.prop in ELEC_BOOL_FLAT) flat = Number(P[ELEC_BOOL_FLAT[f.prop]] || 0);
//         if (serviceType === "Plumber"     && f.prop in PLUMBER_BOOL_FLAT) flat = Number(P[PLUMBER_BOOL_FLAT[f.prop]] || 0);
//         if (serviceType === "Gas Chula"   && f.prop in GAS_BOOL_FLAT)    flat = Number(P[GAS_BOOL_FLAT[f.prop]] || 0);
//         if (serviceType === "Filter"      && f.prop in FILTER_BOOL_FLAT) flat = Number(P[FILTER_BOOL_FLAT[f.prop]] || 0);

//         rows.push({ label: f.prop.replaceAll("_"," "), calc: "", total: fmtTk(flat) });
//         subtotal += flat;
//       }
//     });

//     if (hasAnySelection && P.base > 0) {
//       rows.push({ label: "Booking Fee", calc: "", total: fmtTk(P.base) });
//       subtotal += Number(P.base) || 0;
//     }

//     const discount = Math.max(0, Number(discountValue) || 0);
//     const total = Math.max(0, subtotal - discount);
//     return { subtotal: Math.round(subtotal), discount, total: Math.round(total), breakdownRows: rows };
//   }, [serviceType, fields, discountValue, hasAnySelection]); // UPDATED

//   const canSubmit =
//     user.mobile && user.city && user.area && user.Address &&
//     schedule.date && schedule.time;

//   // UPDATED: include discountValue in payload
//   const place = async ()=>{
//     if (!canSubmit) { alert("Fill all required fields."); return; }
//     try{
//       setPlacing(true);
//       const payload = { serviceType, user, schedule, fields, discountValue }; // UPDATED
//       const { data } = await axios.post(`${URL}/admin/orders`, payload);
//       alert(`Order placed: ${data?.order?.order_number || ""}`);
//       setFields({});
//       setDiscountValue(0); // UPDATED: reset discount after placing
//     }catch(e){
//       console.error(e);
//       alert(e?.response?.data?.message || e?.response?.data?.error || "Failed to place order");
//     }finally{
//       setPlacing(false);
//     }
//   };

//   /* Render each field as a “card” */
//   const renderField = (f) => {
//     const title = f.prop.replaceAll("_"," ").replace(/\b\w/g, c => c.toUpperCase());
//     const perUnit = perUnitRate(serviceType, f.prop);
//     const hint = f.type === "number"
//       ? (serviceType==="AC Service" ? "Tiered pricing by unit" :
//          serviceType==="Home Cleaning" && MAP_HOME_FIRSTFREE[f.prop] ? "First unit free" :
//          perUnit ? `৳${perUnit} per unit` : undefined)
//       : (f.type === "boolean" ? "Enable if needed" : undefined);

//     if (f.type === "number") {
//       const val = Number(fields[f.prop] || 0);
//       return (
//         <Col md={6} lg={4} key={f.prop}>
//           <NumberCard
//             title={title}
//             value={val}
//             onChange={(v)=>setFields({...fields, [f.prop]: v})}
//             unit="units"
//             hint={hint}
//           />
//         </Col>
//       );
//     }

//     if (f.type === "boolean") {
//       const checked = !!fields[f.prop];
//       const priceNote =
//         serviceType==="Electrician" && (f.prop in ELEC_BOOL_FLAT) ? `Flat ৳${ALL_PRICING[serviceType][ELEC_BOOL_FLAT[f.prop]]}` :
//         serviceType==="Plumber"    && (f.prop in PLUMBER_BOOL_FLAT) ? `Flat ৳${ALL_PRICING[serviceType][PLUMBER_BOOL_FLAT[f.prop]]}` :
//         serviceType==="Gas Chula"  && (f.prop in GAS_BOOL_FLAT) ?    `Flat ৳${ALL_PRICING[serviceType][GAS_BOOL_FLAT[f.prop]]}` :
//         serviceType==="Filter"     && (f.prop in FILTER_BOOL_FLAT) ? `Flat ৳${ALL_PRICING[serviceType][FILTER_BOOL_FLAT[f.prop]]}` :
//         undefined;

//       return (
//         <Col md={6} lg={4} key={f.prop}>
//           <ToggleCard
//             title={title}
//             checked={checked}
//             onChange={(v)=>setFields({...fields, [f.prop]: v})}
//             priceNote={priceNote}
//             hint={hint}
//           />
//         </Col>
//       );
//     }

//     // text
//     return (
//       <Col md={6} lg={4} key={f.prop}>
//         <TextFieldCard
//           title={title}
//           value={fields[f.prop]}
//           onChange={(v)=>setFields({...fields, [f.prop]: v})}
//           placeholder="Type here"
//           hint={hint}
//         />
//       </Col>
//     );
//   };

//   const icon = SERVICE_ICONS[serviceType];

//   return (
//     <Container fluid className="apo-container">
//       <Card className="apo-card">
//         <Card.Header className="apo-header">
//           <div className="apo-header-left">
//             <div className="apo-service-icon">{icon}</div>
//             <div>
//               <h3 className="apo-title">Place Order (Admin)</h3>
//               <div className="apo-sub">Create a new {serviceType} order</div>
//             </div>
//           </div>
//           <div style={{minWidth:240}}>
//             <Form.Select
//               value={serviceType}
//               onChange={(e)=>{ setServiceType(e.target.value); setFields({}); }}
//             >
//               {SERVICES.map(s=><option key={s}>{s}</option>)}
//             </Form.Select>
//           </div>
//         </Card.Header>

//         <Card.Body>
//           {/* Service fields */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">Service Details</Card.Header>
//                 <Card.Body>
//                   <Row className="g-3">
//                     {(serviceFields[serviceType]||[]).map(renderField)}
//                   </Row>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {/* UPDATED: Price block with breakdown + discount input */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">Price</Card.Header>
//                 <Card.Body>
//                   {/* Breakdown */}
//                   {pricing.breakdownRows?.length > 0 ? (
//                     <Table bordered responsive className="mb-3">
//                       <thead>
//                         <tr>
//                           <th style={{width:"55%"}}>Item</th>
//                           <th style={{width:"25%"}} className="text-end">Calc</th>
//                           <th style={{width:"20%"}} className="text-end">Line Total</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {pricing.breakdownRows.map((r, idx) => (
//                           <tr key={idx}>
//                             <td>{r.label}</td>
//                             <td className="text-end">{r.calc}</td>
//                             <td className="text-end">{r.total}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </Table>
//                   ) : (
//                     <div className="text-muted mb-3">No selections yet.</div>
//                   )}

//                   {/* Summary + Discount */}
//                   <Row className="align-items-end">
//                     <Col md={6} lg={7}>
//                       <Row className="g-2">
//                         <Col md={6}>
//                           <Form.Label>Discount (৳)</Form.Label>
//                           <Form.Control
//                             type="number"
//                             min={0}
//                             value={discountValue}
//                             onChange={(e)=>setDiscountValue(Math.max(0, Number(e.target.value) || 0))}
//                             placeholder="0"
//                           />
//                         </Col>
//                       </Row>
//                     </Col>
//                     <Col md={6} lg={5}>
//                       <Table bordered responsive className="mb-0">
//                         <tbody>
//                           <tr>
//                             <th>Subtotal</th>
//                             <td className="text-end">৳{pricing.subtotal}</td>
//                           </tr>
//                           <tr>
//                             <th>Discount</th>
//                             <td className="text-end">৳{pricing.discount}</td>
//                           </tr>
//                           <tr>
//                             <th>Total</th>
//                             <td className="text-end">
//                               <Badge bg="success" pill>৳{pricing.total}</Badge>
//                             </td>
//                           </tr>
//                         </tbody>
//                       </Table>
//                     </Col>
//                   </Row>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {/* User & schedule */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">User & Schedule</Card.Header>
//                 <Card.Body>
//                   <Row className="g-3">
//                     <Col md={4}>
//                       <Form.Label><FaPhone/> Mobile *</Form.Label>
//                       <div className="d-flex align-items-center gap-2">
//                         <Form.Control
//                           value={user.mobile}
//                           onChange={(e)=>setUser({...user, mobile: e.target.value.replace(/\s/g,'')})}
//                           placeholder="11-digit mobile"
//                           maxLength={11}
//                         />
//                         {lookingUp && <Spinner size="sm" animation="border" />}
//                       </div>
//                       {foundUser && (
//                         <div className="mt-1">
//                           <small className="text-success">Existing user found (ID: {foundUser.Id})</small>
//                         </div>
//                       )}
//                       {!foundUser && /^\d{11}$/.test(user.mobile) && !lookingUp && (
//                         <div className="mt-1">
//                           <small className="text-muted">New user — fill details below</small>
//                         </div>
//                       )}
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label><FaUser/> First Name</Form.Label>
//                       <Form.Control value={user.FirstName} onChange={(e)=>setUser({...user, FirstName: e.target.value})}/>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Last Name</Form.Label>
//                       <Form.Control value={user.LastName} onChange={(e)=>setUser({...user, LastName: e.target.value})}/>
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label><FaMapMarkerAlt/> City *</Form.Label>
//                       <Form.Select
//                         value={user.city}
//                         onChange={(e)=>{
//                           const name = e.target.value;
//                           const div = divisions.find(d=>d.name===name) || {};
//                           setUser({...user, city: name, cityCode: div.code || "", area:""});
//                         }}
//                       >
//                         <option value="">Select City</option>
//                         {divisions.map(d=><option key={d.name} value={d.name}>{d.name}</option>)}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Area *</Form.Label>
//                       <Form.Select
//                         value={user.area}
//                         onChange={(e)=>setUser({...user, area: e.target.value})}
//                         disabled={!user.city}
//                       >
//                         <option value="">Select Area</option>
//                         {areas.map(a=><option key={a.name} value={a.name}>{a.name}</option>)}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Address *</Form.Label>
//                       <Form.Control value={user.Address} onChange={(e)=>setUser({...user, Address: e.target.value})}/>
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label><FaCalendar/> Date *</Form.Label>
//                       <Form.Control type="date" min={todayISO()} value={schedule.date} onChange={(e)=>setSchedule({...schedule, date: e.target.value})}/>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Time *</Form.Label>
//                       <Form.Select value={schedule.time} onChange={(e)=>setSchedule({...schedule, time: e.target.value})}>
//                         <option value="">Select Time</option>
//                         {timeSlots.map(t=><option key={t}>{t}</option>)}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4} className="d-flex align-items-end">
//                       <Button className="w-100" variant="success" disabled={!canSubmit || placing} onClick={place}>
//                         {placing ? <><Spinner size="sm" animation="border" className="me-2" />Placing…</> : <><FaClipboardCheck className="me-2"/>Place Order</>}
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// }




// FILE: AdminPlaceOrder.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import {
//   Container, Card, Row, Col, Form, Button, Table, Badge, Spinner, OverlayTrigger, Tooltip
// } from "react-bootstrap";
// import {
//   FaBolt, FaBroom, FaCogs, FaFire, FaSnowflake, FaFilter as FaFilterIcon,
//   FaUser, FaPhone, FaMapMarkerAlt, FaCalendar, FaClipboardCheck, FaInfoCircle, FaCheck
// } from "react-icons/fa";
// import Select from "react-select"; // React-Select
// import { URL } from "../../../config";

// // shared maps
// import { serviceFields } from "../../Services/serviceFields";
// import SERVICE_PRICING, { SERVICE_PRICING as ALL_PRICING, AC_PRICING } from "../../Services/servicePricing";
// import "./AdminPlaceOrder.css";

// /* ---------- small helpers ---------- */
// const pad2 = (n)=>String(n).padStart(2,"0");
// const todayISO = ()=>{ const d=new Date(); return `${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())}`; };
// const generateSlots = ()=>{ const out=[]; for(let h=7; h<=21; h++){ for(let m=0;m<60;m+=30){ let dh=h%12; if(dh===0) dh=12; out.push(`${dh}:${pad2(m)} ${h<12?"AM":"PM"}`);} } return out; };

// /* ---------- pricing helpers (same as backend) ---------- */
// const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };
// const MAP_PLUMBER = {
//   angle_valve_setup:"angleValveSetup", basin_tap_setup:"basinTapSetup", magic_pipe_setup:"magicPipeSetup",
//   basin_waste_pop_up_setup:"bathroomShelfSetup",
//   new_basin_setup_existing_lines:"newBasinSetupExistingLines", bathroom_tap_bib_cock_setup:"bathroomTapBibCockSetup",
//   tissue_holder_setup:"tissueHolderSetup", fill_valve_replacement:"fillValveReplacement",
//   hand_shower_setup:"handShowerSetup", soap_dish_setup:"soapDishSetup", bathroom_shelf_setup:"bathroomShelfSetup",
//   mirror_setup:"mirrorSetup", towel_hanger_setup:"towelHangerSetup", shower_head_setup:"showerHeadSetup",
//   concealed_stopcock_setup:"conceledStopcockSetup", floor_drain_net_setup:"floorDrainNetSetup",
//   toilet_seat_cover_replacement:"toiletSeatCoverReplacement", toilet_seat_complete_installation:"toiletSeatCompleteInstallation",
//   high_commode_installation_existing_lines:"highCommodeInstallationExistingLines", blockage_clearing_high_commode:"blockageClearingHighCommode",
//   blockage_clearing_low_commode:"blockageClearingLowCommode", bathroom_drain_line_cleaning:"bathroomDrainLineCleaning",
//   geyser_installation:"geyserInstallation", kitchen_sink_setup_existing_lines:"kitchenSinkSetupExistingLines",
//   sink_blockage_cleaning:"sinkBlockageCleaning", washing_machine_point_setup:"washingMachinePointSetup"
// };
// const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };
// const MAP_GAS = { NewchulaSetup:"newChulaSetup", chulaSetup:"chulaSetup", burnerSetup:"burnerSetup", burnerCleaning:"burnerCleaning", nozzleReplacement:"nozzleReplacement" };
// const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };
// const MAP_FILTER = { new_filter_setup:"newFilterSetup", installation_filter:"installationFilter", uninstallation_filter:"uninstallationFilter", kit_replacement:"kitReplacement", pipe_leak_or_replace:"pipeLeakOrReplace", full_servicing:"fullServicing" };
// const FILTER_BOOL_FLAT = { check_up:"checkupFlat" };
// const MAP_HOME_FIRSTFREE = { bed:"bedrooms", kitchen:"kitchens", dra_din:"drawingdinning" };
// const MAP_HOME_PERUNIT = { bath:"bathrooms", cloth:"cloths", dish:"dishes", balcony:"balconies", window_grill:"windowGrills", furniture_cleaning:"furniture", stairs_and_railing:"stairsFloors", carpet_cleaning:"carpets" };

// // NOTE: Removed AC_NUMERIC_PROPS / acTierTotal / acCheckupTotal (unused)

// /* per-unit lookup */
// function perUnitRate(service, prop) {
//   const pricing = ALL_PRICING[service];
//   if (!pricing) return 0;
//   if (service === "Electrician") return Number(pricing.perUnit?.[prop] || 0);
//   if (service === "Plumber")   return Number(pricing.perUnit?.[MAP_PLUMBER[prop]] || 0);
//   if (service === "Gas Chula") return Number(pricing.perUnit?.[MAP_GAS[prop]] || 0);
//   if (service === "Filter")    return Number(pricing.perUnit?.[MAP_FILTER[prop]] || 0);
//   if (service === "Home Cleaning") return Number(pricing.perUnit?.[MAP_HOME_PERUNIT[prop]] || 0);
//   return 0;
// }

// const SERVICE_ICONS = {
//   "Electrician": <FaBolt/>, "Home Cleaning": <FaBroom/>, "Plumber": <FaCogs/>, "Gas Chula": <FaFire/>, "AC Service": <FaSnowflake/>, "Filter": <FaFilterIcon/>, "Tutor Service": <FaUser/>
// };
// const SERVICES = Object.keys(serviceFields);

// /* ---------- small UI helpers ---------- */
// function InfoTip({ text }) {
//   if (!text) return null;
//   return (
//     <OverlayTrigger placement="top" overlay={<Tooltip id="tt">{text}</Tooltip>}>
//       <span className="apo-info"><FaInfoCircle/></span>
//     </OverlayTrigger>
//   );
// }

// function NumberCard({ title, value=0, onChange, unit="units", hint }) {
//   return (
//     <div className="sf-card">
//       <div className="sf-card-head">
//         <div className="sf-title">{title}</div>
//         <InfoTip text={hint}/>
//       </div>

//       <div className="sf-stepper">
//         <button
//           type="button"
//           className="sf-stepper-btn sf-minus"
//           aria-label={`Decrease ${title}`}
//           onClick={()=>onChange(Math.max(0, value-1))}
//         >−</button>

//         <div className="sf-stepper-center">
//           <div className="sf-stepper-value">{value}</div>
//           <div className="sf-stepper-unit">{unit}</div>
//         </div>

//         <button
//           type="button"
//           className="sf-stepper-btn sf-plus"
//           aria-label={`Increase ${title}`}
//           onClick={()=>onChange(value+1)}
//         >+</button>
//       </div>
//     </div>
//   );
// }

// function ToggleCard({ title, checked=false, onChange, priceNote, hint }) {
//   return (
//     <div className="sf-card">
//       <div className="sf-card-head">
//         <div className="sf-title">{title}</div>
//         <InfoTip text={hint}/>
//       </div>

//       <div className="sf-toggle">
//         <button
//           type="button"
//           className={`sf-toggle-btn ${checked ? "on" : ""}`}
//           onClick={()=>onChange(!checked)}
//           aria-pressed={checked}
//         >
//           <span className="sf-toggle-knob">{checked && <FaCheck/>}</span>
//           <span className="sf-toggle-label">{checked ? "Yes" : "No"}</span>
//         </button>
//         {priceNote && <div className="sf-price-note">{priceNote}</div>}
//       </div>
//     </div>
//   );
// }

// function TextFieldCard({ title, value, onChange, placeholder, hint }) {
//   return (
//     <div className="sf-card">
//       <div className="sf-card-head">
//         <div className="sf-title">{title}</div>
//         <InfoTip text={hint}/>
//       </div>
//       <Form.Control
//         className="sf-input"
//         value={value || ""}
//         placeholder={placeholder || ""}
//         onChange={(e)=>onChange(e.target.value)}
//       />
//     </div>
//   );
// }

// /* =========================
//    Main Component
//    ========================= */
// export default function AdminPlaceOrder() {
//   const [serviceType, setServiceType] = useState("Electrician");
//   const [fields, setFields] = useState({});
//   const [user, setUser] = useState({ mobile:"", FirstName:"", LastName:"", city:"", cityCode:"", area:"", Address:"" });
//   const [schedule, setSchedule] = useState({ date: todayISO(), time:"" });
//   const [divisions, setDivisions] = useState([]);
//   const [areas, setAreas] = useState([]);
//   const [placing, setPlacing] = useState(false);

//   const [discountValue, setDiscountValue] = useState(0);

//   const timeSlots = useMemo(()=>generateSlots(), []);
//   const [foundUser, setFoundUser] = useState(null);
//   const [lookingUp, setLookingUp] = useState(false);

//   const debounce = (fn, delay=400) => {
//     let t;
//     return (...args) => { clearTimeout(t); t = setTimeout(()=>fn(...args), delay); };
//   };

//   const doLookup = useMemo(() => debounce(async (m) => {
//     if (!/^\d{11}$/.test(m)) { setFoundUser(null); return; }
//     try {
//       setLookingUp(true);
//       const { data } = await axios.get(`${URL}/admin/users/lookup`, { params: { mobile: m } });
//       setFoundUser(data);
//       if (data) {
//         setUser(prev => ({
//           ...prev,
//           mobile: data.mobile || m,
//           FirstName: data.FirstName || "",
//           LastName:  data.LastName  || "",
//           city:      data.city      || "",
//           area:      data.area      || "",
//           Address:   data.Address   || "",
//           userId:    data.Id        || ""
//         }));
//       } else {
//         setUser(prev => ({
//           ...prev, mobile: m, FirstName: "", LastName: "", city: "", area: "", Address: "", userId: ""
//         }));
//       }
//     } catch (e) {
//       console.error(e);
//       setFoundUser(null);
//     } finally {
//       setLookingUp(false);
//     }
//   }, 450), []);

//   useEffect(() => {
//     const m = (user.mobile || "").replace(/\s/g,"");
//     if (m.length === 11) doLookup(m);
//     else setFoundUser(null);
//   }, [user.mobile, doLookup]);

//   // Divisions
//   useEffect(()=>{
//     (async ()=>{
//       try{
//         const { data } = await axios.get(`${URL}/locations/divisions`);
//         const rows = Array.isArray(data)
//           ? data.map(d=>({ name: d.name||d.division||d.title, code: d.code||d.Code||d.id||d.Id }))
//           : [];
//         setDivisions(rows);
//       }catch(e){ console.error(e); }
//     })();
//   },[]);

//   // Areas for division
//   useEffect(()=>{
//     (async ()=>{
//       if (!user.city && !user.cityCode) { setAreas([]); return; }
//       try{
//         const params = user.cityCode ? { divisionCode: user.cityCode } : { division: user.city };
//         const { data } = await axios.get(`${URL}/locations/areas`, { params });
//         const rows = Array.isArray(data) ? data.map(a=>({ name: a.name||a.area||a.title })) : [];
//         setAreas(rows);
//       }catch(e){ console.error(e); setAreas([]); }
//     })();
//   },[user.city, user.cityCode]);

//   // Reset fields when switching service
//   useEffect(()=>{
//     setFields({});
//     setDiscountValue(0);
//   }, [serviceType]);

//   // has any priced selection?
//   const hasAnySelection = useMemo(()=>{
//     const defs = serviceFields[serviceType] || [];
//     for (const f of defs) {
//       if (f.type === "number" && Number(fields[f.prop] || 0) > 0) return true;
//       if (f.type === "boolean" && !!fields[f.prop]) return true;
//     }
//     return false;
//   }, [serviceType, fields]);

//   // pricing + breakdown (and discount)
//   const pricing = useMemo(()=>{
//     const P = SERVICE_PRICING[serviceType];
//     if (!P) return { subtotal: 0, discount: 0, total: 0, breakdownRows: [] };

//     const rows = [];
//     const fmtTk = (n) => `৳${(Number(n) || 0).toLocaleString()}`;
//     const U = (v) => Math.max(0, Number(v) || 0);

//     let subtotal = 0;

//     if (serviceType === "AC Service") {
//       const addTierRow = (label, key) => {
//         const c = U(fields[key]);
//         if (!c) return;
//         const pk = AC_PRICING?.perUnit?.[key];
//         if (!pk) return;
//         const unitPrice = c === 1 ? pk.first : pk.additional;
//         const total = c === 1 ? pk.first : c * pk.additional;
//         rows.push({ label, calc: `${c} × ${fmtTk(unitPrice)} =`, total: fmtTk(total) });
//         subtotal += total;
//       };

//       addTierRow("Install (Outdoor Inside)",  "installation_outdoor_inside");
//       addTierRow("Install (Outdoor Outside)", "installation_outdoor_outside");
//       addTierRow("Uninstall (Outdoor Inside)",  "uninstallation_outdoor_inside");
//       addTierRow("Uninstall (Outdoor Outside)", "uninstallation_outdoor_outside");
//       addTierRow("Cleaning (Outdoor Inside)",  "cleaning_outdoor_inside");
//       addTierRow("Cleaning (Outdoor Outside)", "cleaning_outdoor_outside");

//       const c = U(fields.issue_checkup);
//       if (c > 0) {
//         const { base = 0, includesUnits = 0, extraPerUnit = 0 } = AC_PRICING?.checkup || {};
//         if (c <= includesUnits) {
//           rows.push({ label: "Issue Checkup", calc: `${c} units — ${fmtTk(base)}`, total: fmtTk(base) });
//           subtotal += base;
//         } else {
//           const extra = c - includesUnits;
//           const t = base + extra * extraPerUnit;
//           rows.push({ label: "Issue Checkup", calc: `${includesUnits} units — ${fmtTk(base)} + ${extra} × ${fmtTk(extraPerUnit)} =`, total: fmtTk(t) });
//           subtotal += t;
//         }
//       }

//       if (hasAnySelection && P.base > 0) {
//         rows.push({ label: "Booking Fee", calc: "", total: fmtTk(P.base) });
//         subtotal += Number(P.base) || 0;
//       }

//       const discount = Math.max(0, Number(discountValue) || 0);
//       const total = Math.max(0, subtotal - discount);
//       return { subtotal: Math.round(subtotal), discount, total: Math.round(total), breakdownRows: rows };
//     }

//     if (serviceType === "Home Cleaning") {
//       Object.entries(MAP_HOME_FIRSTFREE).forEach(([fprop, priceKey])=>{
//         const c = U(fields[fprop]);
//         if (!c) return;
//         const perAdd = P.firstFree?.[priceKey]?.perAdditional || 0;
//         const qtyPaid = Math.max(0, c - 1);
//         if (qtyPaid > 0) {
//           const total = qtyPaid * perAdd;
//           rows.push({ label: `${fprop.replaceAll("_"," ")} (after first)`, calc: `${qtyPaid} × ${fmtTk(perAdd)} =`, total: fmtTk(total) });
//           subtotal += total;
//         } else {
//           rows.push({ label: `${fprop.replaceAll("_"," ")} (first free)`, calc: "", total: fmtTk(0) });
//         }
//       });
//       Object.entries(MAP_HOME_PERUNIT).forEach(([fprop, priceKey])=>{
//         const c = U(fields[fprop]);
//         if (!c) return;
//         const rate = Number(P.perUnit?.[priceKey] || 0);
//         const total = c * rate;
//         // FIX: use fprop (previously referenced undefined 'f')
//         rows.push({ label: fprop.replaceAll("_"," "), calc: `${c} × ${fmtTk(rate)} =`, total: fmtTk(total) }); // FIX
//         subtotal += total;
//       });

//       if (hasAnySelection && P.base > 0) {
//         rows.push({ label: "Booking Fee", calc: "", total: fmtTk(P.base) });
//         subtotal += Number(P.base) || 0;
//       }

//       const discount = Math.max(0, Number(discountValue) || 0);
//       const total = Math.max(0, subtotal - discount);
//       return { subtotal: Math.round(subtotal), discount, total: Math.round(total), breakdownRows: rows };
//     }

//     // Generic services
//     (serviceFields[serviceType] || []).forEach((f) => {
//       if (f.type === "number") {
//         const c = U(fields[f.prop]);
//         if (!c) return;
//         const rate = perUnitRate(serviceType, f.prop);
//         const total = c * rate;
//         rows.push({ label: f.prop.replaceAll("_", " "), calc: `${c} × ${fmtTk(rate)} =`, total: fmtTk(total) });
//         subtotal += total;
//       } else if (f.type === "boolean" && !!fields[f.prop]) {
//         let flat = 0;
//         if (serviceType === "Electrician" && f.prop in ELEC_BOOL_FLAT) flat = Number(P[ELEC_BOOL_FLAT[f.prop]] || 0);
//         if (serviceType === "Plumber"     && f.prop in PLUMBER_BOOL_FLAT) flat = Number(P[PLUMBER_BOOL_FLAT[f.prop]] || 0);
//         if (serviceType === "Gas Chula"   && f.prop in GAS_BOOL_FLAT)    flat = Number(P[GAS_BOOL_FLAT[f.prop]] || 0);
//         if (serviceType === "Filter"      && f.prop in FILTER_BOOL_FLAT) flat = Number(P[FILTER_BOOL_FLAT[f.prop]] || 0);

//         rows.push({ label: f.prop.replaceAll("_"," "), calc: "", total: fmtTk(flat) });
//         subtotal += flat;
//       }
//     });

//     if (hasAnySelection && P.base > 0) {
//       rows.push({ label: "Booking Fee", calc: "", total: fmtTk(P.base) });
//       subtotal += Number(P.base) || 0;
//     }

//     const discount = Math.max(0, Number(discountValue) || 0);
//     const total = Math.max(0, subtotal - discount);
//     return { subtotal: Math.round(subtotal), discount, total: Math.round(total), breakdownRows: rows };
//   }, [serviceType, fields, discountValue, hasAnySelection]);

//   // validation
//   const coreOk =
//     user.mobile && user.city && user.area && user.Address &&
//     schedule.date && schedule.time;

//   // required extras by service using existing field props
//   const acExtrasOk = serviceType !== "AC Service" || !hasAnySelection
//     ? true
//     : Boolean((fields.acType || "").trim()) && Boolean((fields.acTon || "").trim());

//   const gasExtrasOk = serviceType !== "Gas Chula" || !hasAnySelection
//     ? true
//     : Boolean((fields.chulaCylinderType || "").trim());

//   const filterExtrasOk = serviceType !== "Filter" || !hasAnySelection
//     ? true
//     : Boolean((fields.filter_type || "").trim());

//   const selectionOk = hasAnySelection;

//   const canSubmit = coreOk && selectionOk && acExtrasOk && gasExtrasOk && filterExtrasOk;

//   // submit
//   const place = async ()=>{
//     if (!canSubmit) {
//       const problems = [];
//       if (!coreOk) problems.push("Fill user & schedule fields");
//       if (!selectionOk) problems.push("Select at least one service item");
//       if (!acExtrasOk) problems.push("Select AC Type and AC Ton");
//       if (!gasExtrasOk) problems.push("Select Cylinder Type");
//       if (!filterExtrasOk) problems.push("Select Filter Type");
//       alert(problems.join("\n"));
//       return;
//     }
//     try{
//       setPlacing(true);
//       const payload = { serviceType, user, schedule, fields, discountValue };
//       const { data } = await axios.post(`${URL}/admin/orders`, payload);
//       alert(`Order placed: ${data?.order?.order_number || ""}`);

//       setFields({});
//       setDiscountValue(0);
//     }catch(e){
//       console.error(e);
//       alert(e?.response?.data?.message || e?.response?.data?.error || "Failed to place order");
//     }finally{
//       setPlacing(false);
//     }
//   };

//   /* Render each field as a “card”. For specific props we override with Select. */
//   const renderField = (f) => {
//     const title = f.prop.replaceAll("_"," ").replace(/\b\w/g, c => c.toUpperCase());
//     const perUnit = perUnitRate(serviceType, f.prop);
//     const hint = f.type === "number"
//       ? (serviceType==="AC Service" ? "Tiered pricing by unit" :
//          serviceType==="Home Cleaning" && MAP_HOME_FIRSTFREE[f.prop] ? "First unit free" :
//          perUnit ? `৳${perUnit} per unit` : undefined)
//       : (f.type === "boolean" ? "Enable if needed" : undefined);

//     // OVERRIDES: react-select for specific "text" props
//     if (serviceType === "AC Service" && (f.prop === "acType" || f.prop === "acTon")) {
//       const isType = f.prop === "acType";
//       const options = isType
//         ? [{value:"Inverter",label:"Inverter"}, {value:"Non-Inverter",label:"Non-Inverter"}]
//         : [{value:"1",label:"1"}, {value:"1.5",label:"1.5"}, {value:"2",label:"2"}, {value:"2.5",label:"2.5"}];

//       const current = String(fields[f.prop] || "")
//         .split(",")
//         .map(s=>s.trim())
//         .filter(Boolean)
//         .map(v => ({ value: v, label: v }));

//       return (
//         <Col md={6} lg={4} key={f.prop}>
//           <Form.Label>
//             {title} {hasAnySelection && <span className="text-danger">*</span>}
//           </Form.Label>
//           <Select
//             isMulti
//             options={options}
//             value={current}
//             onChange={(vals)=>{
//               const str = (vals||[]).map(v=>v.value).join(", ");
//               setFields({...fields, [f.prop]: str});
//             }}
//             placeholder={`Select ${title}`}
//           />
//           <div className="form-text">
//             Selected: {current.length ? current.map(o=>o.value).join(", ") : "—"}
//           </div>
//         </Col>
//       );
//     }

//     if (serviceType === "Gas Chula" && f.prop === "chulaCylinderType") {
//       const options = [{value:"LPG",label:"LPG"}, {value:"Line Gas",label:"Line Gas"}];
//       const current = (fields.chulaCylinderType || "").trim();
//       return (
//         <Col md={6} lg={4} key={f.prop}>
//           <Form.Label>
//             {title} {hasAnySelection && <span className="text-danger">*</span>}
//           </Form.Label>
//           <Select
//             options={options}
//             value={current ? { value: current, label: current } : null}
//             onChange={(val)=>setFields({...fields, chulaCylinderType: val ? val.value : ""})}
//             placeholder="Select Cylinder Type"
//             isClearable
//           />
//         </Col>
//       );
//     }

//     if (serviceType === "Filter" && f.prop === "filter_type") {
//       const options = [
//         { value: "RO", label: "RO" },
//         { value: "UV", label: "UV" },
//         { value: "UF", label: "UF" },
//         { value: "RO+UV", label: "RO+UV" },
//         { value: "Under-sink", label: "Under-sink" },
//         { value: "Countertop", label: "Countertop" },
//         { value: "Others", label: "Others" },
//       ];
//       const current = (fields.filter_type || "").trim();
//       return (
//         <Col md={6} lg={4} key={f.prop}>
//           <Form.Label>
//             {title} {hasAnySelection && <span className="text-danger">*</span>}
//           </Form.Label>
//           <Select
//             options={options}
//             value={current ? { value: current, label: current } : null}
//             onChange={(val)=>setFields({...fields, filter_type: val ? val.value : ""})}
//             placeholder="Select Filter Type"
//             isClearable
//           />
//         </Col>
//       );
//     }
//     // end overrides

//     if (f.type === "number") {
//       const val = Number(fields[f.prop] || 0);
//       return (
//         <Col md={6} lg={4} key={f.prop}>
//           <NumberCard
//             title={title}
//             value={val}
//             onChange={(v)=>setFields({...fields, [f.prop]: v})}
//             unit="units"
//             hint={hint}
//           />
//         </Col>
//       );
//     }

//     if (f.type === "boolean") {
//       const checked = !!fields[f.prop];
//       const priceNote =
//         serviceType==="Electrician" && (f.prop in ELEC_BOOL_FLAT) ? `Flat ৳${ALL_PRICING[serviceType][ELEC_BOOL_FLAT[f.prop]]}` :
//         serviceType==="Plumber"    && (f.prop in PLUMBER_BOOL_FLAT) ? `Flat ৳${ALL_PRICING[serviceType][PLUMBER_BOOL_FLAT[f.prop]]}` :
//         serviceType==="Gas Chula"  && (f.prop in GAS_BOOL_FLAT) ?    `Flat ৳${ALL_PRICING[serviceType][GAS_BOOL_FLAT[f.prop]]}` :
//         serviceType==="Filter"     && (f.prop in FILTER_BOOL_FLAT) ? `Flat ৳${ALL_PRICING[serviceType][FILTER_BOOL_FLAT[f.prop]]}` :
//         undefined;

//       return (
//         <Col md={6} lg={4} key={f.prop}>
//           <ToggleCard
//             title={title}
//             checked={checked}
//             onChange={(v)=>setFields({...fields, [f.prop]: v})}
//             priceNote={priceNote}
//             hint={hint}
//           />
//         </Col>
//       );
//     }

//     return (
//       <Col md={6} lg={4} key={f.prop}>
//         <TextFieldCard
//           title={title}
//           value={fields[f.prop]}
//           onChange={(v)=>setFields({...fields, [f.prop]: v})}
//           placeholder="Type here"
//           hint={hint}
//         />
//       </Col>
//     );
//   };

//   const icon = SERVICE_ICONS[serviceType];

//   return (
//     <Container fluid className="apo-container">
//       <Card className="apo-card">
//         <Card.Header className="apo-header">
//           <div className="apo-header-left">
//             <div className="apo-service-icon">{icon}</div>
//             <div>
//               <h3 className="apo-title">Place Order (Admin)</h3>
//               <div className="apo-sub">Create a new {serviceType} order</div>
//             </div>
//           </div>
//           <div style={{minWidth:240}}>
//             <Form.Select
//               value={serviceType}
//               onChange={(e)=>{ setServiceType(e.target.value); }}
//             >
//               {SERVICES.map(s=><option key={s}>{s}</option>)}
//             </Form.Select>
//           </div>
//         </Card.Header>

//         <Card.Body>
//           {/* Service fields */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">Service Details</Card.Header>
//                 <Card.Body>
//                   <Row className="g-3">
//                     {(serviceFields[serviceType]||[]).map(renderField)}
//                   </Row>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {/* Price */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">Price</Card.Header>
//                 <Card.Body>
//                   {pricing.breakdownRows?.length > 0 ? (
//                     <Table bordered responsive className="mb-3">
//                       <thead>
//                         <tr>
//                           <th style={{width:"55%"}}>Item</th>
//                           <th style={{width:"25%"}} className="text-end">Calc</th>
//                           <th style={{width:"20%"}} className="text-end">Line Total</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {pricing.breakdownRows.map((r, idx) => (
//                           <tr key={idx}>
//                             <td>{r.label}</td>
//                             <td className="text-end">{r.calc}</td>
//                             <td className="text-end">{r.total}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </Table>
//                   ) : (
//                     <div className="text-muted mb-3">No selections yet.</div>
//                   )}

//                   <Row className="align-items-end">
//                     <Col md={6} lg={7}>
//                       <Row className="g-2">
//                         <Col md={6}>
//                           <Form.Label>Discount (৳)</Form.Label>
//                           <Form.Control
//                             type="number"
//                             min={0}
//                             value={discountValue}
//                             onChange={(e)=>setDiscountValue(Math.max(0, Number(e.target.value) || 0))}
//                             placeholder="0"
//                           />
//                         </Col>
//                       </Row>
//                     </Col>
//                     <Col md={6} lg={5}>
//                       <Table bordered responsive className="mb-0">
//                         <tbody>
//                           <tr>
//                             <th>Subtotal</th>
//                             <td className="text-end">৳{pricing.subtotal}</td>
//                           </tr>
//                           <tr>
//                             <th>Discount</th>
//                             <td className="text-end">৳{pricing.discount}</td>
//                           </tr>
//                           <tr>
//                             <th>Total</th>
//                             <td className="text-end">
//                               <Badge bg="success" pill>৳{pricing.total}</Badge>
//                             </td>
//                           </tr>
//                         </tbody>
//                       </Table>
//                     </Col>
//                   </Row>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {/* User & schedule */}
//           <Row className="g-3">
//             <Col md={12}>
//               <Card className="apo-block">
//                 <Card.Header className="apo-block-title">User & Schedule</Card.Header>
//                 <Card.Body>
//                   <Row className="g-3">
//                     <Col md={4}>
//                       <Form.Label><FaPhone/> Mobile *</Form.Label>
//                       <div className="d-flex align-items-center gap-2">
//                         <Form.Control
//                           value={user.mobile}
//                           onChange={(e)=>setUser({...user, mobile: e.target.value.replace(/\s/g,'')})}
//                           placeholder="11-digit mobile"
//                           maxLength={11}
//                         />
//                         {lookingUp && <Spinner size="sm" animation="border" />}
//                       </div>
//                       {foundUser && (
//                         <div className="mt-1">
//                           <small className="text-success">Existing user found (ID: {foundUser.Id})</small>
//                         </div>
//                       )}
//                       {!foundUser && /^\d{11}$/.test(user.mobile) && !lookingUp && (
//                         <div className="mt-1">
//                           <small className="text-muted">New user — fill details below</small>
//                         </div>
//                       )}
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label><FaUser/> First Name</Form.Label>
//                       <Form.Control value={user.FirstName} onChange={(e)=>setUser({...user, FirstName: e.target.value})}/>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Last Name</Form.Label>
//                       <Form.Control value={user.LastName} onChange={(e)=>setUser({...user, LastName: e.target.value})}/>
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label><FaMapMarkerAlt/> City *</Form.Label>
//                       <Form.Select
//                         value={user.city}
//                         onChange={(e)=>{
//                           const name = e.target.value;
//                           const div = divisions.find(d=>d.name===name) || {};
//                           setUser({...user, city: name, cityCode: div.code || "", area:""});
//                         }}
//                       >
//                         <option value="">Select City</option>
//                         {divisions.map(d=><option key={d.name} value={d.name}>{d.name}</option>)}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Area *</Form.Label>
//                       <Form.Select
//                         value={user.area}
//                         onChange={(e)=>setUser({...user, area: e.target.value})}
//                         disabled={!user.city}
//                       >
//                         <option value="">Select Area</option>
//                         {areas.map(a=><option key={a.name} value={a.name}>{a.name}</option>)}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Address *</Form.Label>
//                       <Form.Control value={user.Address} onChange={(e)=>setUser({...user, Address: e.target.value})}/>
//                     </Col>

//                     <Col md={4}>
//                       <Form.Label><FaCalendar/> Date *</Form.Label>
//                       <Form.Control type="date" min={todayISO()} value={schedule.date} onChange={(e)=>setSchedule({...schedule, date: e.target.value})}/>
//                     </Col>
//                     <Col md={4}>
//                       <Form.Label>Time *</Form.Label>
//                       <Form.Select value={schedule.time} onChange={(e)=>setSchedule({...schedule, time: e.target.value})}>
//                         <option value="">Select Time</option>
//                         {timeSlots.map(t=><option key={t}>{t}</option>)}
//                       </Form.Select>
//                     </Col>
//                     <Col md={4} className="d-flex align-items-end">
//                       <Button className="w-100" variant="success" disabled={!canSubmit || placing} onClick={place}>
//                         {placing ? <><Spinner size="sm" animation="border" className="me-2" />Placing…</> : <><FaClipboardCheck className="me-2"/>Place Order</>}
//                       </Button>
//                       {/* Inline validation hints */}
//                       {!selectionOk && <div className="text-danger ms-2 small">Add at least one item</div>}
//                       {serviceType==="AC Service" && hasAnySelection && !acExtrasOk && <div className="text-danger ms-2 small">Pick AC Type & Ton</div>}
//                       {serviceType==="Gas Chula" && hasAnySelection && !gasExtrasOk && <div className="text-danger ms-2 small">Pick Cylinder Type</div>}
//                       {serviceType==="Filter" && hasAnySelection && !filterExtrasOk && <div className="text-danger ms-2 small">Pick Filter Type</div>}
//                     </Col>
//                   </Row>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// }











// ***** Upper code is all okay, just set here Auth for protection (2-Dec-2025) ***** //
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Table,
  Badge,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  FaBolt,
  FaBroom,
  FaCogs,
  FaFire,
  FaSnowflake,
  FaFilter as FaFilterIcon,
  FaUser,
  FaPhone,
  FaMapMarkerAlt,
  FaCalendar,
  FaClipboardCheck,
  FaInfoCircle,
  FaCheck,
} from "react-icons/fa";
import Select from "react-select"; // React-Select
import { URL } from "../../../config";

// shared maps
import { serviceFields } from "../../Services/serviceFields";
import SERVICE_PRICING, {
  SERVICE_PRICING as ALL_PRICING,
  AC_PRICING,
} from "../../Services/servicePricing";
import "./AdminPlaceOrder.css";

/* ---------- small helpers ---------- */
const pad2 = (n) => String(n).padStart(2, "0");
const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};
const generateSlots = () => {
  const out = [];
  for (let h = 7; h <= 21; h++) {
    for (let m = 0; m < 60; m += 30) {
      let dh = h % 12;
      if (dh === 0) dh = 12;
      out.push(`${dh}:${pad2(m)} ${h < 12 ? "AM" : "PM"}`);
    }
  }
  return out;
};

/* ---------- admin auth helper ---------- */
const getAdminHeaders = () => {
  const adminToken = localStorage.getItem("adminToken");
  if (!adminToken) return null;
  return {
    Authorization: `Bearer ${adminToken}`,
  };
};

/* ---------- pricing helpers (same as backend) ---------- */
const MAP_ELEC = {
  new_ceiling_fan_installation: "newCeilingFanInstallation",
  ceiling_fan_installation: "ceilingFanInstallation",
  ceiling_fan_uninstallation: "ceilingFanUninstallation",
  fan_coil_new_winding: "fanCoilNewWinding",
  fan_coil_repair: "fanCoilRepair",
  capacitor_setup: "capacitorSetup",
  light_installation: "lightInstallation",
  light_repair: "lightRepair",
  exhaust_fan_installation: "exhaustFanInstallation",
  exhaust_fan_cleaning: "exhaustFanCleaning",
  switch_setup: "switchSetup",
  socket_setup: "socketSetup",
  regulator_setup: "regulatorSetup",
  new_wiring_point: "newWiringPoint",
  main_circuit_board_setup: "mainCircuitBoardSetup",
  doorbell_installation: "doorbellInstallation",
  drill_hole_service: "drillHoleService",
  ips_installation_existing_line: "ipsInstallationExistingLine",
  ips_new_line_installation: "ipsNewLineInstallation",
};

const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };
const MAP_PLUMBER = {
  angle_valve_setup: "angleValveSetup",
  basin_tap_setup: "basinTapSetup",
  magic_pipe_setup: "magicPipeSetup",
  basin_waste_pop_up_setup: "basinWastePopUpSetup",
  new_basin_setup_existing_lines: "newBasinSetupExistingLines",
  bathroom_tap_bib_cock_setup: "bathroomTapBibCockSetup",
  tissue_holder_setup: "tissueHolderSetup",
  fill_valve_replacement: "fillValveReplacement",
  hand_shower_setup: "handShowerSetup",
  soap_dish_setup: "soapDishSetup",
  bathroom_shelf_setup: "bathroomShelfSetup",
  mirror_setup: "mirrorSetup",
  towel_hanger_setup: "towelHangerSetup",
  shower_head_setup: "showerHeadSetup",
  concealed_stopcock_setup: "concealedStopcockSetup",
  floor_drain_net_setup: "floorDrainNetSetup",
  toilet_seat_cover_replacement: "toiletSeatCoverReplacement",
  toilet_seat_complete_installation: "toiletSeatCompleteInstallation",
  high_commode_installation_existing_lines:
    "highCommodeInstallationExistingLines",
  blockage_clearing_high_commode: "blockageClearingHighCommode",
  blockage_clearing_low_commode: "blockageClearingLowCommode",
  bathroom_drain_line_cleaning: "bathroomDrainLineCleaning",
  geyser_installation: "geyserInstallation",
  kitchen_sink_setup_existing_lines: "kitchenSinkSetupExistingLines",
  sink_blockage_cleaning: "sinkBlockageCleaning",
  washing_machine_point_setup: "washingMachinePointSetup",
};
const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };
const MAP_GAS = {
  NewchulaSetup: "newChulaSetup",
  chulaSetup: "chulaSetup",
  burnerSetup: "burnerSetup",
  burnerCleaning: "burnerCleaning",
  nozzleReplacement: "nozzleReplacement",
};
const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };
const MAP_FILTER = {
  new_filter_setup: "newFilterSetup",
  installation_filter: "installationFilter",
  uninstallation_filter: "uninstallationFilter",
  kit_replacement: "kitReplacement",
  pipe_leak_or_replace: "pipeLeakOrReplace",
  full_servicing: "fullServicing",
};
const FILTER_BOOL_FLAT = { check_up: "checkupFlat" };
const MAP_HOME_FIRSTFREE = {
  bed: "bedrooms",
  kitchen: "kitchens",
  dra_din: "drawingdinning",
};
const MAP_HOME_PERUNIT = {
  bath: "bathrooms",
  cloth: "cloths",
  dish: "dishes",
  balcony: "balconies",
  window_grill: "windowGrills",
  furniture_cleaning: "furniture",
  stairs_and_railing: "stairsFloors",
  carpet_cleaning: "carpets",
};

// NOTE: Removed AC_NUMERIC_PROPS / acTierTotal / acCheckupTotal (unused)

const firstAdditionalTotal = (rate, qty) => {
  const q = Math.max(0, Number(qty) || 0);
  if (!q) return 0;

  const first = Number(rate?.first ?? 0);
  const additional = Number(rate?.additional ?? rate?.first ?? 0);

  return first + Math.max(0, q - 1) * additional;
};


const toCamel = (s) =>
  String(s || "").replace(/_([a-z])/g, (_, c) => c.toUpperCase());

/* per-unit lookup */
function perUnitRate(service, prop) {
  const pricing = ALL_PRICING[service];
  if (!pricing) return 0;

  if (service === "Electrician") {
  // Try keys in 3 ways (fixes your "rate: 0" issue)
  const key1 = MAP_ELEC[prop];     // if mapping exists
  const key2 = toCamel(prop);      // convert snake_case -> camelCase

  const rate =
    pricing.perUnit?.[key1] ??
    pricing.perUnit?.[key2] ??
    pricing.perUnit?.[prop];       // fallback if pricing is snake_case

  // drill hole tiered object support
  const isDrill =
    key1 === "drillHoleService" ||
    key2 === "drillHoleService" ||
    prop === "drill_hole_service";

  if (isDrill && rate && typeof rate === "object") {
    return rate; // { first, additional }
  }

  return Number(rate) || 0;
}

  if (service === "Plumber") return Number(pricing.perUnit?.[MAP_PLUMBER[prop]] || 0);
  if (service === "Gas Chula") return Number(pricing.perUnit?.[MAP_GAS[prop]] || 0);
  if (service === "Filter") return Number(pricing.perUnit?.[MAP_FILTER[prop]] || 0);
  if (service === "Home Cleaning") return Number(pricing.perUnit?.[MAP_HOME_PERUNIT[prop]] || 0);

  return 0;
}

const calcPlatformFee = (pricing, workSubtotal) => {
  const amount = Math.max(0, Number(workSubtotal) || 0);
  if (!amount) return 0;

  if (pricing?.platformFee && typeof pricing.platformFee === "object") {
    const percent = Number(pricing.platformFee.percent || 0);
    const min = Number(pricing.platformFee.min || 0);
    const fee = Math.round(amount * percent);
    return Math.max(min, fee);
  }

  return Math.max(0, Number(pricing?.base || 0));
};


const SERVICE_ICONS = {
  Electrician: <FaBolt />,
  "Home Cleaning": <FaBroom />,
  Plumber: <FaCogs />,
  "Gas Chula": <FaFire />,
  "AC Service": <FaSnowflake />,
  Filter: <FaFilterIcon />,
  "Tutor Service": <FaUser />,
};
const SERVICES = Object.keys(serviceFields);

/* ---------- small UI helpers ---------- */
function InfoTip({ text }) {
  if (!text) return null;
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tt">{text}</Tooltip>}
    >
      <span className="apo-info">
        <FaInfoCircle />
      </span>
    </OverlayTrigger>
  );
}

function NumberCard({ title, value = 0, onChange, unit = "units", hint }) {
  return (
    <div className="sf-card">
      <div className="sf-card-head">
        <div className="sf-title">{title}</div>
        <InfoTip text={hint} />
      </div>

      <div className="sf-stepper">
        <button
          type="button"
          className="sf-stepper-btn sf-minus"
          aria-label={`Decrease ${title}`}
          onClick={() => onChange(Math.max(0, value - 1))}
        >
          −
        </button>

        <div className="sf-stepper-center">
          <div className="sf-stepper-value">{value}</div>
          <div className="sf-stepper-unit">{unit}</div>
        </div>

        <button
          type="button"
          className="sf-stepper-btn sf-plus"
          aria-label={`Increase ${title}`}
          onClick={() => onChange(value + 1)}
        >
          +
        </button>
      </div>
    </div>
  );
}

function ToggleCard({ title, checked = false, onChange, priceNote, hint }) {
  return (
    <div className="sf-card">
      <div className="sf-card-head">
        <div className="sf-title">{title}</div>
        <InfoTip text={hint} />
      </div>

      <div className="sf-toggle">
        <button
          type="button"
          className={`sf-toggle-btn ${checked ? "on" : ""}`}
          onClick={() => onChange(!checked)}
          aria-pressed={checked}
        >
          <span className="sf-toggle-knob">{checked && <FaCheck />}</span>
          <span className="sf-toggle-label">{checked ? "Yes" : "No"}</span>
        </button>
        {priceNote && <div className="sf-price-note">{priceNote}</div>}
      </div>
    </div>
  );
}

function TextFieldCard({ title, value, onChange, placeholder, hint }) {
  return (
    <div className="sf-card">
      <div className="sf-card-head">
        <div className="sf-title">{title}</div>
        <InfoTip text={hint} />
      </div>
      <Form.Control
        className="sf-input"
        value={value || ""}
        placeholder={placeholder || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

/* =========================
   Main Component
   ========================= */
export default function AdminPlaceOrder() {
  const [serviceType, setServiceType] = useState("Electrician");
  const [fields, setFields] = useState({});
  const [user, setUser] = useState({
    mobile: "",
    FirstName: "",
    LastName: "",
    city: "",
    cityCode: "",
    area: "",
    Address: "",
  });
  const [schedule, setSchedule] = useState({ date: todayISO(), time: "" });
  const [divisions, setDivisions] = useState([]);
  const [areas, setAreas] = useState([]);
  const [placing, setPlacing] = useState(false);
  const [extraCharge, setExtraCharge] = useState(0);

  const [discountValue, setDiscountValue] = useState(0);

  const [remarks, setRemarks] = useState("");

  const timeSlots = useMemo(() => generateSlots(), []);
  const [foundUser, setFoundUser] = useState(null);
  const [lookingUp, setLookingUp] = useState(false);

  const [customServices, setCustomServices] = useState([]);
  const [customName, setCustomName] = useState("");
  const [customPrice, setCustomPrice] = useState(0);


  const debounce = (fn, delay = 400) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };

  const doLookup = useMemo(
    () =>
      debounce(async (m) => {
        if (!/^\d{11}$/.test(m)) {
          setFoundUser(null);
          return;
        }
        try {
          const headers = getAdminHeaders();
          if (!headers) {
            console.error("Admin token missing for user lookup");
            setFoundUser(null);
            return;
          }

          setLookingUp(true);
          const { data } = await axios.get(`${URL}/admin/users/lookup`, {
            params: { mobile: m },
            headers,
          });
          setFoundUser(data);
          if (data) {
            setUser((prev) => ({
              ...prev,
              mobile: data.mobile || m,
              FirstName: data.FirstName || "",
              LastName: data.LastName || "",
              city: data.city || "",
              area: data.area || "",
              Address: data.Address || "",
              userId: data.Id || "",
            }));
          } else {
            setUser((prev) => ({
              ...prev,
              mobile: m,
              FirstName: "",
              LastName: "",
              city: "",
              area: "",
              Address: "",
              userId: "",
            }));
          }
        } catch (e) {
          console.error(e);
          setFoundUser(null);
        } finally {
          setLookingUp(false);
        }
      }, 450),
    []
  );

  useEffect(() => {
    const m = (user.mobile || "").replace(/\s/g, "");
    if (m.length === 11) doLookup(m);
    else setFoundUser(null);
  }, [user.mobile, doLookup]);

  // Divisions
  useEffect(() => {
    (async () => {
      try {
        const headers = getAdminHeaders();
        if (!headers) {
          console.error("Admin token missing for /locations/divisions");
          return;
        }

        const { data } = await axios.get(`${URL}/locations/divisions`, {
          headers,
        });
        const rows = Array.isArray(data)
          ? data.map((d) => ({
              name: d.name || d.division || d.title,
              code: d.code || d.Code || d.id || d.Id,
            }))
          : [];
        setDivisions(rows);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  // Areas for division
  useEffect(() => {
    (async () => {
      if (!user.city && !user.cityCode) {
        setAreas([]);
        return;
      }
      try {
        const headers = getAdminHeaders();
        if (!headers) {
          console.error("Admin token missing for /locations/areas");
          setAreas([]);
          return;
        }

        const params = user.cityCode
          ? { divisionCode: user.cityCode }
          : { division: user.city };
        const { data } = await axios.get(`${URL}/locations/areas`, {
          params,
          headers,
        });
        const rows = Array.isArray(data)
          ? data.map((a) => ({ name: a.name || a.area || a.title }))
          : [];
        setAreas(rows);
      } catch (e) {
        console.error(e);
        setAreas([]);
      }
    })();
  }, [user.city, user.cityCode]);

  // Reset fields when switching service
  useEffect(() => {
    setFields({});
    setDiscountValue(0);
    setExtraCharge(0);

    setCustomServices([]);
    setCustomName("");
    setCustomPrice(0);
  }, [serviceType]);

  // has any priced selection?
  const hasAnySelection = useMemo(() => {
    if (customServices.length > 0) return true;
    const defs = serviceFields[serviceType] || [];
    for (const f of defs) {
      if (f.type === "number" && Number(fields[f.prop] || 0) > 0) return true;
      if (f.type === "boolean" && !!fields[f.prop]) return true;
    }
    return false;
  }, [serviceType, fields, customServices]);

  // pricing + breakdown (and discount)
  const pricing = useMemo(() => {
  const P = SERVICE_PRICING[serviceType];
  if (!P) return { subtotal: 0, discount: 0, extra: 0, total: 0, breakdownRows: [] };

  const rows = [];
  const fmtTk = (n) => `৳${(Number(n) || 0).toLocaleString()}`;
  const U = (v) => Math.max(0, Number(v) || 0);

  // ✅ workSubtotal = all work items + custom items (NO platform fee yet)
  let workSubtotal = 0;

  const addCustomRows = () => {
    if (!customServices.length) return;
    customServices.forEach((c) => {
      const name = String(c?.name || "").trim();
      const price = Math.max(0, Number(c?.price || 0));
      if (!name) return;

      rows.push({ label: `Other: ${name}`, calc: "", total: fmtTk(price) });
      workSubtotal += price;
    });
  };

  // ---------------- AC Service ----------------
  if (serviceType === "AC Service") {
    const addTierRow = (label, key) => {
      const c = U(fields[key]);
      if (!c) return;
      const pk = AC_PRICING?.perUnit?.[key];
      if (!pk) return;

      const unitPrice = c === 1 ? pk.first : pk.additional;
      const lineTotal = c === 1 ? pk.first : c * pk.additional;

      rows.push({ label, calc: `${c} × ${fmtTk(unitPrice)} =`, total: fmtTk(lineTotal) });
      workSubtotal += lineTotal;
    };

    addTierRow("Install (Outdoor Inside)", "installation_outdoor_inside");
    addTierRow("Install (Outdoor Outside)", "installation_outdoor_outside");
    addTierRow("Uninstall (Outdoor Inside)", "uninstallation_outdoor_inside");
    addTierRow("Uninstall (Outdoor Outside)", "uninstallation_outdoor_outside");
    addTierRow("Cleaning (Outdoor Inside)", "cleaning_outdoor_inside");
    addTierRow("Cleaning (Outdoor Outside)", "cleaning_outdoor_outside");

    const c = U(fields.issue_checkup);
    if (c > 0) {
      const { base = 0, includesUnits = 0, extraPerUnit = 0 } = AC_PRICING?.checkup || {};
      if (c <= includesUnits) {
        rows.push({ label: "Issue Checkup", calc: `${c} units — ${fmtTk(base)}`, total: fmtTk(base) });
        workSubtotal += base;
      } else {
        const extra = c - includesUnits;
        const t = base + extra * extraPerUnit;
        rows.push({
          label: "Issue Checkup",
          calc: `${includesUnits} units — ${fmtTk(base)} + ${extra} × ${fmtTk(extraPerUnit)} =`,
          total: fmtTk(t),
        });
        workSubtotal += t;
      }
    }

    addCustomRows();

    // ✅ platform fee based on workSubtotal (and custom included)
    const platformFee = hasAnySelection ? calcPlatformFee(P, workSubtotal) : 0;
    if (hasAnySelection && platformFee > 0) {
      rows.push({
        label: "Platform & Support Fee",
        calc: P?.platformFee ? `${Math.round((P.platformFee.percent || 0) * 100)}% (min ৳${P.platformFee.min || 0})` : "",
        total: fmtTk(platformFee),
      });
    }

    const subtotal = Math.round(workSubtotal + platformFee);
    const discount = Math.max(0, Number(discountValue) || 0);
    const extraChargeSafe = Math.max(0, Number(extraCharge) || 0);
    const total = Math.max(0, subtotal - discount + extraChargeSafe);

    return { subtotal, discount, extra: extraChargeSafe, total: Math.round(total), breakdownRows: rows };
  }

  // ---------------- Home Cleaning ----------------
  if (serviceType === "Home Cleaning") {
    Object.entries(MAP_HOME_FIRSTFREE).forEach(([fprop, priceKey]) => {
      const c = U(fields[fprop]);
      if (!c) return;

      const perAdd = Number(P.firstFree?.[priceKey]?.perAdditional || 0);
      const qtyPaid = Math.max(0, c - 1);

      if (qtyPaid > 0) {
        const t = qtyPaid * perAdd;
        rows.push({ label: `${fprop.replaceAll("_", " ")} (after first)`, calc: `${qtyPaid} × ${fmtTk(perAdd)} =`, total: fmtTk(t) });
        workSubtotal += t;
      } else {
        rows.push({ label: `${fprop.replaceAll("_", " ")} (first free)`, calc: "", total: fmtTk(0) });
      }
    });

    Object.entries(MAP_HOME_PERUNIT).forEach(([fprop, priceKey]) => {
      const c = U(fields[fprop]);
      if (!c) return;

      const rate = Number(P.perUnit?.[priceKey] || 0);
      const t = c * rate;

      rows.push({ label: fprop.replaceAll("_", " "), calc: `${c} × ${fmtTk(rate)} =`, total: fmtTk(t) });
      workSubtotal += t;
    });

    addCustomRows();

    const platformFee = hasAnySelection ? calcPlatformFee(P, workSubtotal) : 0;
    if (hasAnySelection && platformFee > 0) {
      rows.push({
        label: "Platform & Support Fee",
        calc: P?.platformFee ? `${Math.round((P.platformFee.percent || 0) * 100)}% (min ৳${P.platformFee.min || 0})` : "",
        total: fmtTk(platformFee),
      });
    }

    const subtotal = Math.round(workSubtotal + platformFee);
    const discount = Math.max(0, Number(discountValue) || 0);
    const extraChargeSafe = Math.max(0, Number(extraCharge) || 0);
    const total = Math.max(0, subtotal - discount + extraChargeSafe);

    return { subtotal, discount, extra: extraChargeSafe, total: Math.round(total), breakdownRows: rows };
  }

  // ---------------- Generic services (Electrician / Plumber / Gas / Filter / etc.) ----------------
  (serviceFields[serviceType] || []).forEach((f) => {
    if (f.type === "number") {
      const c = U(fields[f.prop]);
      if (!c) return;

      const rate = perUnitRate(serviceType, f.prop);

      // ✅ drill hole tiered row
      if (serviceType === "Electrician" && f.prop === "drill_hole_service" && rate && typeof rate === "object") {
        const t = firstAdditionalTotal(rate, c);
        rows.push({
          label: f.prop.replaceAll("_", " "),
          calc: `${c} holes — first ৳${rate.first}, next ৳${rate.additional} =`,
          total: fmtTk(t),
        });
        workSubtotal += t;
        return;
      }

      const unit = Number(rate) || 0;
      const t = c * unit;

      rows.push({ label: f.prop.replaceAll("_", " "), calc: `${c} × ${fmtTk(unit)} =`, total: fmtTk(t) });
      workSubtotal += t;
    }

    if (f.type === "boolean" && !!fields[f.prop]) {
      let flat = 0;
      if (serviceType === "Electrician" && f.prop in ELEC_BOOL_FLAT) flat = Number(P[ELEC_BOOL_FLAT[f.prop]] || 0);
      if (serviceType === "Plumber" && f.prop in PLUMBER_BOOL_FLAT) flat = Number(P[PLUMBER_BOOL_FLAT[f.prop]] || 0);
      if (serviceType === "Gas Chula" && f.prop in GAS_BOOL_FLAT) flat = Number(P[GAS_BOOL_FLAT[f.prop]] || 0);
      if (serviceType === "Filter" && f.prop in FILTER_BOOL_FLAT) flat = Number(P[FILTER_BOOL_FLAT[f.prop]] || 0);

      rows.push({ label: f.prop.replaceAll("_", " "), calc: "", total: fmtTk(flat) });
      workSubtotal += flat;
    }
  });

  addCustomRows();

  const platformFee = hasAnySelection ? calcPlatformFee(P, workSubtotal) : 0;
  if (hasAnySelection && platformFee > 0) {
    rows.push({
      label: "Platform & Support Fee",
      calc: P?.platformFee ? `${Math.round((P.platformFee.percent || 0) * 100)}% (min ৳${P.platformFee.min || 0})` : "",
      total: fmtTk(platformFee),
    });
  }

  const subtotal = Math.round(workSubtotal + platformFee);
  const discount = Math.max(0, Number(discountValue) || 0);
  const extraChargeSafe = Math.max(0, Number(extraCharge) || 0);
  const total = Math.max(0, subtotal - discount + extraChargeSafe);

  return { subtotal, discount, extra: extraChargeSafe, total: Math.round(total), breakdownRows: rows };
}, [serviceType, fields, discountValue, extraCharge, hasAnySelection, customServices]);

  // validation
  const coreOk =
    user.mobile &&
    user.city &&
    user.area &&
    user.Address &&
    schedule.date &&
    schedule.time;

  // required extras by service using existing field props
  const acExtrasOk =
    serviceType !== "AC Service" || !hasAnySelection
      ? true
      : Boolean((fields.acType || "").trim()) &&
        Boolean((fields.acTon || "").trim());

  const gasExtrasOk =
    serviceType !== "Gas Chula" || !hasAnySelection
      ? true
      : Boolean((fields.chulaCylinderType || "").trim());

  const filterExtrasOk =
    serviceType !== "Filter" || !hasAnySelection
      ? true
      : Boolean((fields.filter_type || "").trim());

  const selectionOk = hasAnySelection;

  const canSubmit =
    coreOk && selectionOk && acExtrasOk && gasExtrasOk && filterExtrasOk;

  // submit
  const place = async () => {
    if (!canSubmit) {
      const problems = [];
      if (!coreOk) problems.push("Fill user & schedule fields");
      if (!selectionOk) problems.push("Select at least one service item");
      if (!acExtrasOk) problems.push("Select AC Type and AC Ton");
      if (!gasExtrasOk) problems.push("Select Cylinder Type");
      if (!filterExtrasOk) problems.push("Select Filter Type");
      alert(problems.join("\n"));
      return;
    }
    try {
      setPlacing(true);

      const headers = getAdminHeaders();
      if (!headers) {
        alert("Not authorized. Please login as admin.");
        setPlacing(false);
        return;
      }

      const payload = { serviceType, user, schedule, fields, discountValue, extraCharge, remarks: remarks.trim() || "", customServices,};
      const { data } = await axios.post(`${URL}/admin/orders`, payload, {
        headers,
      });
      alert(`Order placed: ${data?.order?.order_number || ""}`);

      setFields({});
      setDiscountValue(0);
      setExtraCharge(0);
      setRemarks("");
      setCustomServices([]);
      setCustomName("");
      setCustomPrice(0);
    } catch (e) {
      console.error(e);
      alert(
        e?.response?.data?.message ||
          e?.response?.data?.error ||
          "Failed to place order"
      );
    } finally {
      setPlacing(false);
    }
  };

  /* Render each field as a “card”. For specific props we override with Select. */
  const renderField = (f) => {
    const title = f.prop
      .replaceAll("_", " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
    const perUnit = perUnitRate(serviceType, f.prop);
    if (serviceType === "Electrician") {
      console.log("ELEC prop:", f.prop, "mapKey:", MAP_ELEC[f.prop], "rate:", perUnit);
    }

    const hint =
      f.type === "number"
        ? serviceType === "AC Service"
          ? "Tiered pricing by unit"
          : serviceType === "Home Cleaning" && MAP_HOME_FIRSTFREE[f.prop]
          ? "First unit free"
          : perUnit
          ? typeof perUnit === "object"
            ? `Tiered (first ৳${perUnit.first}, next ৳${perUnit.additional})`
            : `৳${perUnit} per unit`
          : undefined
        : f.type === "boolean"
        ? "Enable if needed"
        : undefined;

    // OVERRIDES: react-select for specific "text" props
    if (
      serviceType === "AC Service" &&
      (f.prop === "acType" || f.prop === "acTon")
    ) {
      const isType = f.prop === "acType";
      const options = isType
        ? [
            { value: "Inverter", label: "Inverter" },
            { value: "Non-Inverter", label: "Non-Inverter" },
          ]
        : [
            { value: "1", label: "1" },
            { value: "1.5", label: "1.5" },
            { value: "2", label: "2" },
            { value: "2.5", label: "2.5" },
          ];

      const current = String(fields[f.prop] || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((v) => ({ value: v, label: v }));

      return (
        <Col md={6} lg={4} key={f.prop}>
          <Form.Label>
            {title} {hasAnySelection && <span className="text-danger">*</span>}
          </Form.Label>
          <Select
            isMulti
            options={options}
            value={current}
            onChange={(vals) => {
              const str = (vals || []).map((v) => v.value).join(", ");
              setFields({ ...fields, [f.prop]: str });
            }}
            placeholder={`Select ${title}`}
          />
          <div className="form-text">
            Selected:{" "}
            {current.length ? current.map((o) => o.value).join(", ") : "—"}
          </div>
        </Col>
      );
    }

    if (serviceType === "Gas Chula" && f.prop === "chulaCylinderType") {
      const options = [
        { value: "LPG", label: "LPG" },
        { value: "Line Gas", label: "Line Gas" },
      ];
      const current = (fields.chulaCylinderType || "").trim();
      return (
        <Col md={6} lg={4} key={f.prop}>
          <Form.Label>
            {title} {hasAnySelection && <span className="text-danger">*</span>}
          </Form.Label>
          <Select
            options={options}
            value={current ? { value: current, label: current } : null}
            onChange={(val) =>
              setFields({
                ...fields,
                chulaCylinderType: val ? val.value : "",
              })
            }
            placeholder="Select Cylinder Type"
            isClearable
          />
        </Col>
      );
    }

    if (serviceType === "Filter" && f.prop === "filter_type") {
      const options = [
        { value: "RO", label: "RO" },
        { value: "UV", label: "UV" },
        { value: "UF", label: "UF" },
        { value: "RO+UV", label: "RO+UV" },
        { value: "Under-sink", label: "Under-sink" },
        { value: "Countertop", label: "Countertop" },
        { value: "Others", label: "Others" },
      ];
      const current = (fields.filter_type || "").trim();
      return (
        <Col md={6} lg={4} key={f.prop}>
          <Form.Label>
            {title} {hasAnySelection && <span className="text-danger">*</span>}
          </Form.Label>
          <Select
            options={options}
            value={current ? { value: current, label: current } : null}
            onChange={(val) =>
              setFields({
                ...fields,
                filter_type: val ? val.value : "",
              })
            }
            placeholder="Select Filter Type"
            isClearable
          />
        </Col>
      );
    }
    // end overrides

    if (f.type === "number") {
      const val = Number(fields[f.prop] || 0);
      return (
        <Col md={6} lg={4} key={f.prop}>
          <NumberCard
            title={title}
            value={val}
            onChange={(v) => setFields({ ...fields, [f.prop]: v })}
            unit="units"
            hint={hint}
          />
        </Col>
      );
    }

    if (f.type === "boolean") {
      const checked = !!fields[f.prop];
      const priceNote =
        serviceType === "Electrician" && f.prop in ELEC_BOOL_FLAT
          ? `Flat ৳${ALL_PRICING[serviceType][ELEC_BOOL_FLAT[f.prop]]}`
          : serviceType === "Plumber" && f.prop in PLUMBER_BOOL_FLAT
          ? `Flat ৳${ALL_PRICING[serviceType][PLUMBER_BOOL_FLAT[f.prop]]}`
          : serviceType === "Gas Chula" && f.prop in GAS_BOOL_FLAT
          ? `Flat ৳${ALL_PRICING[serviceType][GAS_BOOL_FLAT[f.prop]]}`
          : serviceType === "Filter" && f.prop in FILTER_BOOL_FLAT
          ? `Flat ৳${ALL_PRICING[serviceType][FILTER_BOOL_FLAT[f.prop]]}`
          : undefined;

      return (
        <Col md={6} lg={4} key={f.prop}>
          <ToggleCard
            title={title}
            checked={checked}
            onChange={(v) => setFields({ ...fields, [f.prop]: v })}
            priceNote={priceNote}
            hint={hint}
          />
        </Col>
      );
    }

    return (
      <Col md={6} lg={4} key={f.prop}>
        <TextFieldCard
          title={title}
          value={fields[f.prop]}
          onChange={(v) => setFields({ ...fields, [f.prop]: v })}
          placeholder="Type here"
          hint={hint}
        />
      </Col>
    );
  };

  const icon = SERVICE_ICONS[serviceType];

  return (
    <Container fluid className="apo-container">
      <Card className="apo-card">
        <Card.Header className="apo-header">
          <div className="apo-header-left">
            <div className="apo-service-icon">{icon}</div>
            <div>
              <h3 className="apo-title">Place Order (Admin)</h3>
              <div className="apo-sub">Create a new {serviceType} order</div>
            </div>
          </div>
          <div style={{ minWidth: 240 }}>
            <Form.Select
              value={serviceType}
              onChange={(e) => {
                setServiceType(e.target.value);
              }}
            >
              {SERVICES.map((s) => (
                <option key={s}>{s}</option>
              ))}
            </Form.Select>
          </div>
        </Card.Header>

        <Card.Body>
          {/* Service fields */}
          <Row className="g-3">
            <Col md={12}>
              <Card className="apo-block">
                <Card.Header className="apo-block-title">
                  Service Details
                </Card.Header>
                {/* <Card.Body>
                  <Row className="g-3">
                    {(serviceFields[serviceType] || []).map(renderField)}
                  </Row>
                </Card.Body> */}

                <Card.Body>
                  <Row className="g-3">

                    {/* ✅ Custom Services (Manual) */}
                    <Col md={12}>
                      <Card className="apo-block mb-3">
                        <Card.Header className="apo-block-title">
                          Other / Custom Service (Manual)
                        </Card.Header>

                        <Card.Body>
                          <Row className="g-2 align-items-end">
                            <Col md={6}>
                              <Form.Label>Service Name</Form.Label>
                              <Form.Control
                                value={customName}
                                onChange={(e) => setCustomName(e.target.value)}
                                placeholder="e.g. Extra repair / Special work"
                              />
                            </Col>

                            <Col md={3}>
                              <Form.Label>Price (৳)</Form.Label>
                              <Form.Control
                                type="number"
                                min={0}
                                value={customPrice}
                                onChange={(e) =>
                                  setCustomPrice(Math.max(0, Number(e.target.value) || 0))
                                }
                                placeholder="0"
                              />
                            </Col>

                            <Col md={3}>
                              <Button
                                className="w-100"
                                variant="primary"
                                onClick={() => {
                                  const name = String(customName || "").trim();
                                  const price = Math.max(0, Number(customPrice || 0));

                                  if (!name) return alert("Custom service name required");

                                  setCustomServices((prev) => [...prev, { name, price }]);
                                  setCustomName("");
                                  setCustomPrice(0);
                                }}
                              >
                                Add
                              </Button>
                            </Col>
                          </Row>

                          {customServices.length > 0 && (
                            <Table bordered responsive className="mt-3 mb-0">
                              <thead>
                                <tr>
                                  <th>Custom Service</th>
                                  <th className="text-end">Price</th>
                                  <th className="text-center" style={{ width: 90 }}>
                                    Remove
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {customServices.map((c, idx) => (
                                  <tr key={idx}>
                                    <td>{c.name}</td>
                                    <td className="text-end">৳{Number(c.price || 0)}</td>
                                    <td className="text-center">
                                      <Button
                                        size="sm"
                                        variant="danger"
                                        onClick={() =>
                                          setCustomServices((prev) =>
                                            prev.filter((_, i) => i !== idx)
                                          )
                                        }
                                      >
                                        X
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Existing service fields */}
                    {(serviceFields[serviceType] || []).map(renderField)}
                  </Row>
                </Card.Body>

              </Card>
            </Col>
          </Row>

          {/* Price */}
          <Row className="g-3">
            <Col md={12}>
              <Card className="apo-block">
                <Card.Header className="apo-block-title">
                  Price
                </Card.Header>
                <Card.Body>
                  {pricing.breakdownRows?.length > 0 ? (
                    <Table bordered responsive className="mb-3">
                      <thead>
                        <tr>
                          <th style={{ width: "55%" }}>Item</th>
                          <th
                            style={{ width: "25%" }}
                            className="text-end"
                          >
                            Calc
                          </th>
                          <th
                            style={{ width: "20%" }}
                            className="text-end"
                          >
                            Line Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {pricing.breakdownRows.map((r, idx) => (
                          <tr key={idx}>
                            <td>{r.label}</td>
                            <td className="text-end">{r.calc}</td>
                            <td className="text-end">{r.total}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div className="text-muted mb-3">
                      No selections yet.
                    </div>
                  )}

                  <Row className="align-items-end">
                    <Col md={6} lg={7}>
                      <Row className="g-2">
                        <Col md={6}>
                          <Form.Label>Discount (৳)</Form.Label>
                          <Form.Control
                            type="number"
                            min={0}
                            value={discountValue}
                            onChange={(e) =>
                              setDiscountValue(
                                Math.max(0, Number(e.target.value) || 0)
                              )
                            }
                            placeholder="0"
                          />
                        </Col>
                      </Row>
                      <Row className="g-2">
                         <Col md={6}>
                          <Form.Label>Extra Service Charge (৳)</Form.Label>
                          <Form.Control
                            type="number"
                            min={0}
                            value={extraCharge}
                            onChange={(e) =>
                              setExtraCharge(
                                Math.max(0, Number(e.target.value) || 0)
                              )
                            }
                            placeholder="0"
                          />
                          <Form.Text className="text-muted">
                            Optional – e.g. emergency / far location
                          </Form.Text>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={6} lg={5}>
                      <Table
                        bordered
                        responsive
                        className="mb-0"
                      >
                        <tbody>
                          <tr>
                            <th>Subtotal</th>
                            <td className="text-end">
                              ৳{pricing.subtotal}
                            </td>
                          </tr>
                          <tr>
                            <th>Discount</th>
                            <td className="text-end">
                              ৳{pricing.discount}
                            </td>
                          </tr>
                          <tr>
                            <th>Extra Service Charge</th>
                            <td className="text-end">৳{pricing.extra || 0}</td>
                          </tr>

                          <tr>
                            <th>Total</th>
                            <td className="text-end">
                              <Badge bg="success" pill>
                                ৳{pricing.total}
                              </Badge>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* User & schedule */}
          <Row className="g-3">
            <Col md={12}>
              <Card className="apo-block">
                <Card.Header className="apo-block-title">
                  User & Schedule
                </Card.Header>
                <Card.Body>
                  <Row className="g-3">
                    <Col md={4}>
                      <Form.Label>
                        <FaPhone /> Mobile *
                      </Form.Label>
                      <div className="d-flex align-items-center gap-2">
                        <Form.Control
                          value={user.mobile}
                          onChange={(e) =>
                            setUser({
                              ...user,
                              mobile: e.target.value.replace(/\s/g, ""),
                            })
                          }
                          placeholder="11-digit mobile"
                          maxLength={11}
                        />
                        {lookingUp && (
                          <Spinner size="sm" animation="border" />
                        )}
                      </div>
                      {foundUser && (
                        <div className="mt-1">
                          <small className="text-success">
                            Existing user found (ID: {foundUser.Id})
                          </small>
                        </div>
                      )}
                      {!foundUser &&
                        /^\d{11}$/.test(user.mobile) &&
                        !lookingUp && (
                          <div className="mt-1">
                            <small className="text-muted">
                              New user — fill details below
                            </small>
                          </div>
                        )}
                    </Col>

                    <Col md={4}>
                      <Form.Label>
                        <FaUser /> First Name
                      </Form.Label>
                      <Form.Control
                        value={user.FirstName}
                        onChange={(e) =>
                          setUser({
                            ...user,
                            FirstName: e.target.value,
                          })
                        }
                      />
                    </Col>
                    <Col md={4}>
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        value={user.LastName}
                        onChange={(e) =>
                          setUser({
                            ...user,
                            LastName: e.target.value,
                          })
                        }
                      />
                    </Col>

                    <Col md={4}>
                      <Form.Label>
                        <FaMapMarkerAlt /> City *
                      </Form.Label>
                      <Form.Select
                        value={user.city}
                        onChange={(e) => {
                          const name = e.target.value;
                          const div =
                            divisions.find((d) => d.name === name) || {};
                          setUser({
                            ...user,
                            city: name,
                            cityCode: div.code || "",
                            area: "",
                          });
                        }}
                      >
                        <option value="">Select City</option>
                        {divisions.map((d) => (
                          <option key={d.name} value={d.name}>
                            {d.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={4}>
                      <Form.Label>Area *</Form.Label>
                      <Form.Select
                        value={user.area}
                        onChange={(e) =>
                          setUser({
                            ...user,
                            area: e.target.value,
                          })
                        }
                        disabled={!user.city}
                      >
                        <option value="">Select Area</option>
                        {areas.map((a) => (
                          <option key={a.name} value={a.name}>
                            {a.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={4}>
                      <Form.Label>Address *</Form.Label>
                      <Form.Control
                        value={user.Address}
                        onChange={(e) =>
                          setUser({
                            ...user,
                            Address: e.target.value,
                          })
                        }
                      />
                    </Col>

                    <Col md={4}>
                      <Form.Label>
                        <FaCalendar /> Date *
                      </Form.Label>
                      <Form.Control
                        type="date"
                        min={todayISO()}
                        value={schedule.date}
                        onChange={(e) =>
                          setSchedule({
                            ...schedule,
                            date: e.target.value,
                          })
                        }
                      />
                    </Col>
                    <Col md={4}>
                      <Form.Label>Time *</Form.Label>
                      <Form.Select
                        value={schedule.time}
                        onChange={(e) =>
                          setSchedule({
                            ...schedule,
                            time: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Time</option>
                        {timeSlots.map((t) => (
                          <option key={t}>{t}</option>
                        ))}
                      </Form.Select>
                    </Col>

                     {/* NEW: optional remarks */}
                    <Col md={4}>
                      <Form.Label>Remarks (optional)</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        placeholder="Any special notes or internal remarks"
                      />
                    </Col>

                    <Col
                      md={4}
                      className="d-flex align-items-end"
                    >
                      <Button
                        className="w-100"
                        variant="success"
                        disabled={!canSubmit || placing}
                        onClick={place}
                      >
                        {placing ? (
                          <>
                            <Spinner
                              size="sm"
                              animation="border"
                              className="me-2"
                            />
                            Placing…
                          </>
                        ) : (
                          <>
                            <FaClipboardCheck className="me-2" />
                            Place Order
                          </>
                        )}
                      </Button>
                      {/* Inline validation hints */}
                      {!selectionOk && (
                        <div className="text-danger ms-2 small">
                          Add at least one item
                        </div>
                      )}
                      {serviceType === "AC Service" &&
                        hasAnySelection &&
                        !acExtrasOk && (
                          <div className="text-danger ms-2 small">
                            Pick AC Type & Ton
                          </div>
                        )}
                      {serviceType === "Gas Chula" &&
                        hasAnySelection &&
                        !gasExtrasOk && (
                          <div className="text-danger ms-2 small">
                            Pick Cylinder Type
                          </div>
                        )}
                      {serviceType === "Filter" &&
                        hasAnySelection &&
                        !filterExtrasOk && (
                          <div className="text-danger ms-2 small">
                            Pick Filter Type
                          </div>
                        )}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
}
